import React, { useState, useRef, useEffect, Fragment, PureComponent } from 'react';
import { ContainerWithLabel, Paragraph, Span, ColorPicker, Spacing, SmallPicker, CheckboxList, GridRow, Button, Heading, Mixins, Icon, Tooltip, SimpleGrid, Toggle, HorizontalBarChart, Divider, Link, Pill, GridColumn, MatchMedia, Modal, Grid, RadioButtonList, RangeSlider, Picker, Accordion, CollapsibleContainer, CollapsibleContainerHeader, CollapsibleContainerBody, useBreakpoints, Gallery, ImageCarousel, FunctionalPickerItem, Image, Loader, Container, CardGrid, FilterList, ColorSwatch, themeWS10, SmallButton, LinkWithIcon, TextInputWithLabel } from 'r10-source-library';
import styled, { css } from 'styled-components';
import vm from 'vm';
import dayjs from 'dayjs';

const defaultCardProps$1 = {
    fallBackImage: 'https://test.digitalretail.vodafone.com/static/media/image_not_found.543510b7.svg',
    cardWidth: '260px',
};

const Img$4 = styled.img `
  width: 100%;
  height: 190px;
  object-fit: contain;
`;
const CardWrapper$3 = styled.div `
  width: ${props => props.cardWidth};
  display: flex;
  flex: 1;
`;
const ImageAndHeadingContainer = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 30px;
  pointer-events: none;
`;
const ContentContainer$1 = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const AccessoryCard = ({ id, title, img, fallBackImage, cardWidth, cardLabel, textSelectorLabel, textSelectorOptions, textSelectorState, onTextSelectorStateChange, addToCartCTA, removeFromCartCTA, paymentData, colorSelectState, colorSelectorOptions, colorSelectorLabel, onColorSelectStateChange, checkboxText, checkboxState, onCheckboxStateChange, isSelected, }) => {
    const cartButtonAppearance = isSelected ? 'primary' : 'secondary';
    const cartButtonText = isSelected ? removeFromCartCTA.text : addToCartCTA.text;
    const showColorPicker = colorSelectorOptions && colorSelectState !== undefined;
    const showTextPicker = textSelectorOptions && textSelectorState !== undefined;
    const buttonAction = () => {
        isSelected
            ? removeFromCartCTA.action({ id })
            : addToCartCTA.action({
                id,
                selectedColor: colorSelectState,
                selectedText: textSelectorState,
                checkbox: checkboxState,
            });
    };
    const renderPaymentOptions = () => {
        return paymentData.map(payment => {
            return payment.label ? (payment.label) : (React.createElement(React.Fragment, null,
                React.createElement(Heading, { size: 1, weight: 4 },
                    payment.price.value,
                    payment.price.unit,
                    "\u00A0"),
                "/\u00A0",
                payment.duration.unit));
        });
    };
    return (React.createElement(CardWrapper$3, { cardWidth: cardWidth },
        React.createElement(ContainerWithLabel, { label: cardLabel, appearance: "secondary" },
            React.createElement(ContentContainer$1, null,
                React.createElement(ImageAndHeadingContainer, null,
                    React.createElement(Img$4, { src: img, alt: title, onError: ({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = fallBackImage;
                        } }),
                    React.createElement(Paragraph, { size: 2, weight: 2 }, title)),
                showColorPicker && (React.createElement(React.Fragment, null,
                    React.createElement(Paragraph, { size: 1, weight: 1 },
                        colorSelectorLabel,
                        " ",
                        React.createElement(Span, { weight: 3 }, colorSelectState)),
                    React.createElement(ColorPicker, { label: "color-picker", items: colorSelectorOptions, selected: colorSelectState, onChange: onColorSelectStateChange, groupName: 'Color choices' }))),
                showTextPicker && (React.createElement(React.Fragment, null,
                    React.createElement(Spacing, { spacingLevel: { top: 2, bottom: 2 } },
                        React.createElement(Paragraph, { size: 1, weight: 1 }, textSelectorLabel),
                        React.createElement(SmallPicker, { label: "color-picker", items: textSelectorOptions, selected: textSelectorState, onChange: onTextSelectorStateChange, groupName: 'Color choices' })))),
                checkboxText && (React.createElement(Spacing, { spacingLevel: { top: 4 } },
                    React.createElement(CheckboxList, { fieldWrapper: { label: 'Acessory card checkbox', showLabel: false }, checkboxes: {
                            groupName: 'Acessory card checkbox',
                            id: 'acessory-card-checkbox',
                            onChange: onCheckboxStateChange,
                            items: [
                                {
                                    label: checkboxText,
                                    checked: checkboxState,
                                    value: checkboxText,
                                },
                            ],
                        } }))),
                React.createElement(GridRow, { justify: "center", marginBottom: 3, marginTop: 3 }, renderPaymentOptions()),
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true },
                    React.createElement(Button, { state: addToCartCTA.state, width: "full", text: cartButtonText, appearance: cartButtonAppearance, onClick: buttonAction }))))));
};
AccessoryCard.defaultProps = defaultCardProps$1;

const CardContainer$1 = styled.div `
  width: ${props => props.width}px;
  height: 100%;
  background-color: ${props => props.backgroundColor};
  padding: ${props => props.padding}px;
  border-radius: ${props => (props.borderRadius ? props.borderRadius : 0)}px;
  ${props => props.promoted &&
    css `
      border: 1px solid ${props => props.theme.color.secondary1.default};
      border-radius: 0px ${props => (props.borderRadius ? props.borderRadius : 0)}px
        ${props => (props.borderRadius ? props.borderRadius : 0)}px
        ${props => (props.borderRadius ? props.borderRadius : 0)}px;
    `}
  ${Mixins.elevation(true)}
  @media only screen and (max-width: 330px) {
    width: 100%;
  }
`;
const Promotion = styled.div `
  height: 30px;
  position: absolute;
  top: -29px;
  display: flex;
  width: fit-content;
  background-color: ${props => props.theme.color.secondary1.default};
  color: white;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 6px 6px 0px 0px;
`;
const Card = props => {
    return (React.createElement("div", { id: `${props.id || ''}-card`, style: { width: 'fit-content', position: 'relative' } },
        props.promoted && props.promotionText && (React.createElement(Promotion, null,
            React.createElement(Paragraph, { appearance: "primary", inverse: true, weight: 3, noMargin: true, size: 1 }, props.promotionText))),
        React.createElement(CardContainer$1, Object.assign({ id: `${props.id || ''}-card-container` }, props), props.children)));
};
Card.defaultProps = {
    width: 330,
    borderRadius: 6,
    promoted: false,
    padding: 20,
    backgroundColor: 'white',
};

const Img$3 = styled.img `
  width: 100%;
  object-fit: contain;
`;
const IconContainer$1 = styled.div `
  margin-top: ${props => props.iconTopMargin}px;
  width: ${props => props.iconWidth}px;
  height: ${props => props.iconHeight}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CommonIcon = props => {
    var _a;
    const { src, fallBackImage } = props;
    const { group, state, appearance } = src;
    const { name, url } = src;
    const [error, setError] = useState(false);
    return (React.createElement(IconContainer$1, { id: `${props.id || '' || '' || ''}-icon-container`, iconWidth: props.width, iconHeight: props.height, iconTopMargin: props.iconTopMargin }, typeof props.src === 'string' || url ? (React.createElement("div", { id: `${props.id || '' || ''}-image`, style: { width: props.width, height: props.height } },
        React.createElement(Img$3, { src: error ? fallBackImage : url || props.src, alt: props.altText || name || '', title: props.altText || name || '', onError: ({ currentTarget }) => {
                currentTarget.onerror = null;
                setError(true);
            } }))) : (React.createElement(Icon, { name: (_a = props.src) === null || _a === void 0 ? void 0 : _a.name, group: group, state: state, inverse: props.inverse, appearance: appearance, size: props.iconSize }))));
};

const ServicesIncludedContainer = styled.div `
  padding: ${props => props.paddingTop}px 0px ${props => props.paddingBottom}px;
`;
const IconsContainer = styled.div `
  display: flex;
  justify-content: ${props => props.justify};
  align-items: center;
`;
const IconContainer = styled.div `
  margin-right: ${props => (props.isLastItem ? 0 : props.distanceBetweenIcons)}px;
`;
const ServicesIncluded = props => {
    return (React.createElement(ServicesIncludedContainer, { id: `${props.id || ''}-services-container`, paddingTop: props.paddingTop, paddingBottom: props.paddingBottom, "data-testid": "servicesIncludedSection" },
        props.text && (React.createElement("div", { style: { marginBottom: props.titleMarginBottom } },
            React.createElement(Paragraph, { noMargin: true, size: 2, justify: "center" }, props.text))),
        React.createElement(IconsContainer, { justify: props.justify },
            props.icons.map((icon, index, allIcons) => (React.createElement(IconContainer, { id: `${props.id || ''}-services-icon${index}`, "data-testid": `service-icon-${index}`, key: `${props.id || ''}-services-icon${index}`, isLastItem: index === allIcons.length - 1 && !props.extraServices && !props.extraServicesText, distanceBetweenIcons: props.distanceBetweenIcons },
                React.createElement(CommonIcon, { src: icon, fallBackImage: props.fallBackImage, iconSize: props.iconsSize, width: props.iconsWidth, height: props.iconsHeight })))),
            props.extraServicesText && !!props.extraServices && (React.createElement(Paragraph, { size: 1, noMargin: true, dataAttributes: { 'data-testid': 'extraServicesText' } }, `+${props.extraServices} ${props.extraServicesText}`)))));
};
ServicesIncluded.defaultProps = {
    titleMarginBottom: 20,
    iconsWidth: 40,
    iconsHeight: 40,
    distanceBetweenIcons: 16,
    justify: 'center',
    paddingTop: 20,
    paddingBottom: 20,
};

const CardBodyContainer$1 = styled.div `
  padding: ${props => props.padding}px 0px;
  margin: ${props => props.margin}px 0px;
  background-color: white;
  height: ${props => (props.isServicesIncludedVisible ? `${props.height}px` : '100%')};
  overflow-y: auto;
`;
const ItemContainer$1 = styled.div `
  display: flex;
  margin-bottom: ${props => (props.isLastItem ? 0 : props => props.distanceBetweenItems)}px;
`;
const CardBody = props => {
    var _a;
    return (React.createElement(CardBodyContainer$1, { id: `${props.id || ''}-cardbody-container`, padding: props.padding, margin: props.margin, isServicesIncludedVisible: props.isServicesIncludedVisible, "data-testid": "featuresSection" }, (_a = props.items) === null || _a === void 0 ? void 0 : _a.map((item, index, items) => {
        return (React.createElement("div", { key: `${props.id || ''}-item${index}` },
            React.createElement(ItemContainer$1, { key: `${props.id || ''}-item${index}`, id: `${props.id || ''}-item-${index}-container`, distanceBetweenItems: props.distanceBetweenItems, isLastItem: index === items.length - 1, "data-testid": `feature-${index}` },
                item.icon && (React.createElement("div", { style: { marginRight: props.distanceBetweenItemsAndIcons } },
                    React.createElement(CommonIcon, { iconTopMargin: props.iconTopMargin, width: props.iconWidth, height: props.iconHeight, src: item.icon, iconSize: props.iconSize }))),
                React.createElement(Paragraph, { noMargin: true, size: 2 }, item.text)),
            React.createElement("div", { style: {
                    marginLeft: props.iconWidth,
                } }, item.servicedIncluded && (React.createElement(ServicesIncluded, Object.assign({ key: `${props.id || ''}-item${index}-servicesIncluded`, id: `${props.id || ''}-item${index}-servicesIncluded`, justify: item.servicedIncluded.justify || 'flex-start', paddingTop: item.servicedIncluded.paddingTop || 10, paddingBottom: item.servicedIncluded.paddingBottom || 10, distanceBetweenIcons: item.servicedIncluded.distanceBetweenIcons || 8 }, item.servicedIncluded))))));
    })));
};
CardBody.defaultProps = {
    iconWidth: 32,
    padding: 0,
    margin: 20,
    iconHeight: 32,
    iconSize: 2,
    iconTopMargin: -2,
    distanceBetweenItems: 10,
    distanceBetweenItemsAndIcons: 0,
    items: [],
    isServicesIncludedVisible: true,
};

const HeaderContainer$1 = styled.div `
  background: ${props => props.backgroundColor};
  min-height: ${props => props.minHeight}px;
  border-radius: ${props => props.borderRadius}px;
  padding: ${props => props.padding}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const HeadingWrapper$1 = styled.div `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const CardHeader$1 = props => {
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const headingRef = useRef(null);
    useEffect(() => {
        if (headingRef === null || headingRef === void 0 ? void 0 : headingRef.current) {
            const { scrollHeight, offsetHeight } = headingRef.current;
            setIsTooltipVisible(scrollHeight > offsetHeight);
        }
    }, []);
    return (React.createElement(HeaderContainer$1, Object.assign({}, props, { id: `${props.id || ''}-header-container` }),
        props.icon && props.icon.name && props.icon.group && (React.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'center',
                marginBottom: props.distanceBetweenIconAndHeader,
            } },
            React.createElement(CommonIcon, { src: props.icon, iconSize: props.iconSize, inverse: true }))),
        props.header && (React.createElement(HeadingWrapper$1, { "data-testid": "cardHeader", ref: headingRef }, isTooltipVisible ? (React.createElement(Tooltip, { size: 1, id: props.header, text: props.header, appearance: "secondary" },
            React.createElement(Heading, { weight: props.headerWeight, noMargin: true, text: props.header, size: props.headerLevel, inverse: true, justify: "center" }))) : (React.createElement(Heading, { weight: props.headerWeight, noMargin: true, text: props.header, size: props.headerLevel, inverse: true, justify: "center" }))))));
};
CardHeader$1.defaultProps = {
    borderRadius: 6,
    distanceBetweenIconAndHeader: 8,
    headerLevel: 4,
    minHeight: 140,
    padding: 16,
    iconSize: 4,
    backgroundColor: 'linear-gradient(45deg, #820000 0%, #e60000 100%)',
};

const defaultPriceHeight = 24;
const PriceOfferingContainer = styled.div `
  padding: ${props => props.padding}px 0px;
  display: flex;
  box-sizing: border-box;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
const DiscountedPrice = styled.p `
  margin: 0;
  font-size: 18px;
  line-height: 26px;
  -webkit-letter-spacing: 0;
  -moz-letter-spacing: 0;
  -ms-letter-spacing: 0;
  text-decoration: line-through;
  letter-spacing: 0;
  font-weight: 400;
  font-family: Vodafone, Open Sans, sans-serif;
  -webkit-font-smoothing: antialiased;
`;
const PriceOffering = props => {
    return (React.createElement(PriceOfferingContainer, { id: `${props.id || ''}-price-offering`, padding: props.padding, "data-testid": "priceOffering" },
        React.createElement("div", { style: { height: props.discountedPrice ? props.priceHeight : 0 } }, props.discountedPrice && (React.createElement(DiscountedPrice, null, `${props.prefixText || ''} ${props.price} ${props.suffixText || ''}`.trim()))),
        props.price && (React.createElement("div", { style: {
                height: props.discountedPrice ? props.priceHeight : 2 * defaultPriceHeight,
                display: props.discountedPrice ? 'block' : 'flex',
                alignItems: props.discountedPrice ? '' : 'center',
            } }, props.price && (React.createElement(Heading, { level: 5, weight: 3, size: 1, text: `
              ${props.prefixText || ''}
              ${props.discountedPrice || props.price}
              ${props.suffixText || ''}`.trim() }))))));
};
PriceOffering.defaultProps = {
    padding: 0,
    priceHeight: defaultPriceHeight,
};

const ToggleWrapper = styled.div `
  > div {
    padding: 0;
  }
`;
const AutoRenewContainer = styled.div `
  height: 28px;
`;
const ExpiryDateContainer = styled.div `
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const RenewAndValidity = props => (React.createElement(SimpleGrid, { layout: {
        sm: [12],
    }, verticalAlign: "center", spacing: 3 },
    props.type && (React.createElement(Paragraph, { size: 2, weight: 2, dataAttributes: { 'data-testid': 'type' } },
        React.createElement(Span, { weight: 3 }, props.typeLabel),
        " ",
        props.type)),
    React.createElement(ExpiryDateContainer, null,
        React.createElement(SimpleGrid, { spacing: 0 },
            React.createElement(Spacing, { spacingLevel: { right: 2 } },
                React.createElement(Icon, { name: props.date.iconName, size: props.date.iconSize, dataAttributes: { 'data-testid': 'dateIcon' } })),
            React.createElement(Span, { weight: 2, dataAttributes: { 'data-testid': 'dateText' } }, props.date.text)),
        props.date.value && (React.createElement(SimpleGrid, { spacing: 0, justify: "right" },
            React.createElement(Span, { weight: 2, dataAttributes: { 'data-testid': 'dateValue' } }, props.date.value)))),
    props.showAutoRenew &&
        (props.autoRenew ? (React.createElement(AutoRenewContainer, null,
            React.createElement(SimpleGrid, { layout: {
                    sm: [9, 3],
                }, spacing: 0 },
                React.createElement(SimpleGrid, { spacing: 0 },
                    React.createElement(Spacing, { spacingLevel: { right: 2 } },
                        React.createElement(Icon, { name: props.autoRenew.iconName, size: props.autoRenew.iconSize })),
                    React.createElement(Span, { weight: 2, dataAttributes: { 'data-testid': 'autoRenew' } }, props.autoRenew.text)),
                React.createElement(SimpleGrid, { spacing: 0, justify: "right" },
                    React.createElement(ToggleWrapper, null,
                        React.createElement(Toggle, { id: "toggle", name: "toggle", value: "toggle", isActive: props.autoRenew.isActive, onChange: () => {
                                var _a;
                                if (props.onChangeToggle) {
                                    props.onChangeToggle(!((_a = props.autoRenew) === null || _a === void 0 ? void 0 : _a.isActive));
                                }
                            }, showIcons: false, dataAttributes: { 'data-testid': 'toggle' } })))))) : (React.createElement(AutoRenewContainer, null)))));

const Consumption = ({ consumptionList }) => {
    const isLastItem = (arr, i) => arr.length - 1 === i;
    return (React.createElement(SimpleGrid, { layout: {
            sm: [12],
        }, verticalAlign: "center", spacing: 3 }, consumptionList.map(({ iconName, percentage, topText, consumptionKey, consumptionValue }, i, arr) => (React.createElement("div", { key: i, "data-testid": `consumptionBar-${i}` },
        React.createElement(Spacing, { spacingLevel: { bottom: isLastItem(arr, i) ? 0 : 4, right: 3 } },
            React.createElement(HorizontalBarChart, { steps: [
                    {
                        key: consumptionKey,
                        value: consumptionValue,
                        percentage: percentage,
                        state: 'error',
                    },
                ], icon: { name: iconName }, topText: { left: topText.left, right: topText.right }, srText: "Data Consumption" })),
        React.createElement(Spacing, { spacingLevel: { right: 3 } }, !isLastItem(arr, i) && React.createElement(Divider, { noMargin: true, appearance: "secondary" })))))));
};

const LinkContainer$3 = styled.div `
  padding: ${props => props.padding}px 0px 0px 0px;
  display: flex;
  justify-content: center;
  & > a {
    color: red !important;
  }
`;
const ButtonContainer$1 = styled.div(props => css `
    padding: ${props.buttonPadding}px 0px 0px 0px;
  `);
const TileButton = props => {
    return (React.createElement("div", { id: `${props.id || ''}-button-container` },
        props.showButton && (React.createElement(ButtonContainer$1, { buttonPadding: props.buttonPadding },
            React.createElement(Button, { text: props.buttonText, width: "full", appearance: props.appearance, onClick: () => {
                    if (props.onClick) {
                        props.onClick(props.id, props.toggleState);
                    }
                }, dataAttributes: {
                    'data-testid': 'CTAButton',
                } }))),
        props.showLink && (React.createElement(LinkContainer$3, { padding: props.padding },
            React.createElement(Link, { onClick: () => {
                    if (props.onClickLink) {
                        props.onClickLink(props.id, props.toggleState);
                    }
                }, href: props.link, text: props.linkText, dataAttributes: {
                    'data-testid': 'CTALink',
                } })))));
};
TileButton.defaultProps = {
    appearance: 'alt1',
    padding: 16,
    buttonPadding: 0,
    showButton: true,
    showLink: false,
};

const defaultPropsForCard$1 = {
    height: 'auto',
    width: 330,
};

const CardWrapper$2 = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
const PillWrapper = styled.div `
  display: flex;
  justify-content: end;
  margin-bottom: 10px;
  height: 26px;
`;
const AddonCard$1 = props => {
    var _a, _b, _c, _d, _e;
    const cardProps = Object.assign(Object.assign({}, defaultPropsForCard$1), props === null || props === void 0 ? void 0 : props.card);
    const [toggleState, setToggleState] = useState(!!((_b = (_a = props.renewAndValidity) === null || _a === void 0 ? void 0 : _a.autoRenew) === null || _b === void 0 ? void 0 : _b.isActive));
    const { showSection, text, state } = (_c = props === null || props === void 0 ? void 0 : props.productStatus) !== null && _c !== void 0 ? _c : {};
    return (React.createElement(Card, Object.assign({}, cardProps),
        React.createElement(CardWrapper$2, null,
            React.createElement("div", null,
                showSection && (React.createElement(PillWrapper, null, text && React.createElement(Pill, { text: text, state: state || 'error' }))),
                React.createElement(CardHeader$1, Object.assign({}, props === null || props === void 0 ? void 0 : props.cardHeader)),
                (props === null || props === void 0 ? void 0 : props.priceOffering) && (React.createElement(React.Fragment, null,
                    React.createElement(PriceOffering, Object.assign({}, props === null || props === void 0 ? void 0 : props.priceOffering)),
                    React.createElement(Divider, { noMargin: true, appearance: "secondary" }))),
                props.cardBody && (React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                    } },
                    React.createElement(CardBody, Object.assign({}, props.cardBody, { isServicesIncludedVisible: !!((_e = (_d = props.servicesIncluded) === null || _d === void 0 ? void 0 : _d.icons) === null || _e === void 0 ? void 0 : _e.length) })))),
                !props.cardBody && (React.createElement(React.Fragment, null,
                    props.servicesIncluded && React.createElement(ServicesIncluded, Object.assign({}, props === null || props === void 0 ? void 0 : props.servicesIncluded)),
                    props.renewAndValidity && (React.createElement(React.Fragment, null,
                        React.createElement(Spacing, { spacingLevel: { top: 3, bottom: 3 } },
                            React.createElement(RenewAndValidity, Object.assign({}, props.renewAndValidity, { autoRenew: props.renewAndValidity.autoRenew && Object.assign(Object.assign({}, props.renewAndValidity.autoRenew), { isActive: toggleState }), onChangeToggle: state => setToggleState(state) }))))),
                    props.consumption && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, { noMargin: true, appearance: "secondary" }),
                        React.createElement(Spacing, { spacingLevel: { top: 3, bottom: 3 } },
                            React.createElement(Consumption, Object.assign({}, props.consumption)))))))),
            React.createElement("div", null,
                props.cardBody && (React.createElement(React.Fragment, null,
                    props.servicesIncluded && React.createElement(ServicesIncluded, Object.assign({}, props === null || props === void 0 ? void 0 : props.servicesIncluded)),
                    props.renewAndValidity && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, { noMargin: true, appearance: "secondary" }),
                        React.createElement(Spacing, { spacingLevel: { top: 3, bottom: 3 } },
                            React.createElement(RenewAndValidity, Object.assign({}, props.renewAndValidity, { autoRenew: props.renewAndValidity.autoRenew && Object.assign(Object.assign({}, props.renewAndValidity.autoRenew), { isActive: toggleState }), onChangeToggle: state => setToggleState(state) }))))),
                    props.consumption && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, { noMargin: true, appearance: "secondary" }),
                        React.createElement(Spacing, { spacingLevel: { top: 3, bottom: 3 } },
                            React.createElement(Consumption, Object.assign({}, props.consumption))))))),
                React.createElement(Spacing, { spacingLevel: { top: 4 } },
                    React.createElement(TileButton, Object.assign({}, props === null || props === void 0 ? void 0 : props.tileButton, { id: props.id, toggleState: toggleState })))))));
};

const DatesContainer = styled.div `
  padding: ${props => props.padding}px 0px;
  display: flex;
  justify-content: space-between;
`;
const defaultProps$2 = {
    iconWidth: 36,
    padding: 20,
    iconTopMargin: 0,
    iconSize: 1,
    textSize: 2,
    icon: {
        name: 'calendar-month',
        group: 'system',
    },
};
const AddonDate = exposedProps => {
    const props = Object.assign(Object.assign({}, defaultProps$2), exposedProps);
    return (React.createElement(DatesContainer, { id: `${props.id || ''}-dates-container`, padding: props.padding },
        React.createElement("div", { id: `${props.id || ''}-dates-title-container`, style: { display: 'flex' } },
            React.createElement(CommonIcon, { id: props.id || '', iconTopMargin: props.iconTopMargin, iconSize: props.iconSize, width: props.iconWidth, src: props === null || props === void 0 ? void 0 : props.icon }),
            React.createElement(Paragraph, { size: props.textSize, noMargin: true }, props.text)),
        React.createElement("div", { id: `${props.id || ''}-dates-date-container` },
            React.createElement(Paragraph, { size: props.textSize, noMargin: true }, props.date))));
};
AddonDate.defaultProps = defaultProps$2;

function TrayHeader({ heading }) {
    return (React.createElement(GridRow, null,
        React.createElement(Span, { weight: 3, dataAttributes: { 'data-testid': 'trayHeader' } }, heading)));
}

const TrayContent = ({ data, handleChange, selectedRowId }) => {
    const pillWrapper = (row, leftSpacing) => (React.createElement(Spacing, { spacingLevel: { left: leftSpacing } },
        React.createElement(Pill, { text: row.pillTitle, appearance: "primary", dataAttributes: { 'data-testid': 'pill-title' } })));
    const renderIconName = (rowId) => selectedRowId === rowId ? 'tick-circle' : 'chevron-right';
    const renderSection = ({ sectionTitle, sectionDetails }, index) => {
        return (React.createElement(Fragment, { key: index },
            React.createElement(GridRow, { marginBottom: 2, marginTop: 8 },
                React.createElement(Heading, { size: 2, weight: 1, text: sectionTitle, noMargin: false, dataAttributes: { 'data-testid': `section-${index}` } }),
                React.createElement(Divider, { appearance: "primary" })),
            sectionDetails.map((row, index) => (React.createElement("div", { "data-testid": 'addresscontent' + `${index}`, style: { cursor: 'pointer' }, onClick: () => handleChange(row.id), key: row.id },
                React.createElement(GridRow, null,
                    React.createElement(GridColumn, { col: 9 },
                        React.createElement(GridRow, { marginBottom: 2 },
                            React.createElement(Heading, { weight: 3, size: 1, noMargin: true, text: row.addressHeader, dataAttributes: { 'data-testid': 'addressHeader' + `${index}` } }),
                            row.pillTitle && (React.createElement(React.Fragment, null,
                                React.createElement(MatchMedia, { breakpoint: "sm" }, pillWrapper(row, 1)),
                                React.createElement(MatchMedia, { breakpoint: "md", andAbove: true }, pillWrapper(row, 5))))),
                        React.createElement(GridRow, null,
                            React.createElement(Span, { appearance: "alt2", dataAttributes: { 'data-testid': 'fullAddress' + `${index}` } }, row.fullAddress)),
                        React.createElement(GridRow, null,
                            React.createElement(Span, { appearance: "alt2", dataAttributes: { 'data-testid': 'phoneNumber' + `${index}` } }, row.phoneNumber))),
                    React.createElement(GridColumn, { alignSelf: "center" },
                        React.createElement(GridRow, { justify: "end", noGutters: true },
                            React.createElement(Icon, { name: renderIconName(row.id), state: selectedRowId === row.id ? 'success' : 'error', group: "system", size: 4, dataAttributes: { 'data-testid': renderIconName(row.id) } }))),
                    React.createElement(Divider, { appearance: "primary" })))))));
    };
    return React.createElement(React.Fragment, null, data.map((el, index) => renderSection(el, index)));
};

const AddressTray = ({ data, heading, isOpen, setIsOpen, handleChange, selectedRowId, }) => {
    return (React.createElement(Modal, { srName: "modal", isOpen: isOpen, size: 4, animate: true, isClosable: true, onCloseCb: () => setIsOpen(false), dataAttributes: { 'data-testid': 'tray' } },
        React.createElement(Grid, { maxWidth: 610 },
            React.createElement(TrayHeader, { heading: heading }),
            React.createElement(TrayContent, { data: data, handleChange: handleChange, selectedRowId: selectedRowId }))));
};

const CompareContainer = styled.div `
  /* padding: 20px 0px 0px 0px; */
  display: flex;
`;
const Compare = props => {
    const [isChecked, setIsChecked] = useState([false]);
    const updateCheckboxStates = (value) => {
        const itemIndex = radioItems.findIndex(radioItem => radioItem.value === value);
        const newValue = !isChecked[itemIndex];
        const newCheckboxStates = [...isChecked];
        newCheckboxStates.splice(itemIndex, 1, newValue);
        setIsChecked(newCheckboxStates);
        if (props.onChange) {
            props.onChange(newCheckboxStates[0]);
        }
    };
    const radioItems = [
        {
            label: 'Compare',
            value: 'Compare',
            checked: isChecked[0],
        },
    ];
    return (React.createElement(CompareContainer, { id: `${props.id || ''}-compare` },
        React.createElement(CheckboxList, { checkboxes: {
                groupName: 'Vertical',
                id: 'product-checkbox',
                onChange: event => {
                    updateCheckboxStates(event.target.value);
                },
                items: radioItems,
            }, fieldWrapper: {
                label: '',
            } }, props.text)));
};

const ErrorContent = (props) => {
    var _a, _b, _c;
    const onClick = () => {
        props.buttonAction && props.buttonAction();
        props.onClickCb && props.onClickCb();
    };
    return (React.createElement(React.Fragment, null,
        props.IsCustomClose && !props.isClosable && (React.createElement(GridRow, { justify: "end", noGutters: true },
            React.createElement("span", { onClick: onClick, style: { cursor: 'pointer' } },
                React.createElement(Icon, { name: "close", group: "system", size: 5 })))),
        React.createElement("div", { style: { textAlign: 'center' } },
            React.createElement(Spacing, { spacingLevel: { bottom: 3 } },
                React.createElement(Icon, { name: props.icon, size: props.iconSize, group: "hifiLight" })),
            React.createElement(Heading, { size: 2, weight: 3, dataAttributes: { 'data-testid': props.titleTestId } }, props.title),
            React.createElement(Paragraph, { weight: 2, dataAttributes: { 'data-testid': props.descriptionTestId } }, props.description),
            (props.buttonText || ((_a = props.secondaryButton) === null || _a === void 0 ? void 0 : _a.text)) && (React.createElement(React.Fragment, null,
                props.buttonText && (React.createElement(GridRow, { justify: "center", marginBottom: ((_b = props.secondaryButton) === null || _b === void 0 ? void 0 : _b.text) ? 3 : 0, noGutters: true },
                    React.createElement(Button, { dataAttributes: {
                            'data-testid': props.actionButtonTestId || 'action-button',
                        }, text: props.buttonText, width: props.fullWidth ? 'full' : 'auto', onClick: onClick }))),
                ((_c = props.secondaryButton) === null || _c === void 0 ? void 0 : _c.text) && (React.createElement(GridRow, { justify: "center", noGutters: true },
                    React.createElement(Button, { dataAttributes: {
                            'data-testid': props.secondaryButton.dataTestId || 'secondary-button',
                        }, text: props.secondaryButton.text, width: props.fullWidth ? 'full' : 'auto', appearance: props.secondaryButton.appearance || 'alt1', onClick: props.secondaryButton.onClick }))))))));
};

const ErrorModal = props => {
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const onModalClose = () => {
        setIsOpen(false);
    };
    return (React.createElement(Modal, { srName: "Error", isOpen: isOpen, size: 2, type: "modal", isClosable: props.hasCloseIcon, overlayBlur: true, onCloseCb: props.onClose },
        React.createElement("div", { style: { textAlign: 'center' } },
            React.createElement(ErrorContent, { isClosable: props.hasCloseIcon, IsCustomClose: props.IsCustomClose, icon: props.icon, iconSize: 4, title: props.title, description: props.description, titleTestId: props.titleTestId, descriptionTestId: props.descriptionTestId, actionButtonTestId: props.actionButtonTestId, buttonText: props.buttonText, buttonAction: props.buttonAction, onClickCb: onModalClose, fullWidth: true, secondaryButton: props.secondaryButton }))));
};

const RadioFilter = props => {
    const handleOnChange = (event) => {
        const checkedValue = event.target.value;
        props.onChange &&
            props.onChange(props.id, Object.assign({
                title: props.title,
                id: props.id,
                items: props.items,
                value: props.value,
                type: 'radio',
            }, { value: checkedValue }));
    };
    return (React.createElement(RadioButtonList, { fieldWrapper: {
            label: '',
            showLabel: false,
        }, orientation: "horizontal", radioButtons: {
            id: props.id,
            items: props.items,
            checked: props.value,
            groupName: props.title,
            onChange: handleOnChange,
        } }));
};

class ToggleFilter extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnChange = (id) => {
            // Map through items, see which one is checked
            const newToggles = this.props.items.map((toggle, index) => {
                if (id === index)
                    return Object.assign(Object.assign({}, toggle), { isActive: !toggle.isActive });
                return toggle;
            });
            const updatedToggleFilter = {
                type: 'toggle',
                title: this.props.title,
                id: this.props.id,
                items: newToggles,
            };
            this.props.onChange(this.props.id, updatedToggleFilter);
        };
    }
    get activeToggles() {
        return this.props.items.reduce((activeNumber, item) => {
            return activeNumber + (item.isActive ? 1 : 0);
        }, 0);
    }
    get shouldRenderInline() {
        var _a;
        const { items } = this.props;
        // should render inline if accordion is disabled and has only one filter without an image nor a label
        return items.length === 1 && !((_a = items[0].img) === null || _a === void 0 ? void 0 : _a.length) && !items[0].label;
    }
    render() {
        return (React.createElement(React.Fragment, null, this.props.items.map((item, index) => {
            return (React.createElement(Toggle, { key: index, id: `${this.props.id}-${index}`, name: `toggle-filter-${this.props.id}`, value: `toggle-${index}`, isActive: item.isActive, showIcons: false, onChange: () => this.handleOnChange(index) }));
        })));
    }
}

const RangeSliderFilter = props => {
    var _a, _b, _c;
    const [centerText, setCenterText] = useState(((_a = props.value) === null || _a === void 0 ? void 0 : _a.length) ? `${props.value[0]}-${props.value[1]}` : `${props.min}-${props.max}`);
    useEffect(() => {
        var _a;
        {
            ((_a = props.value) === null || _a === void 0 ? void 0 : _a.length)
                ? setCenterText(`${props.value[0]}-${props.value[1]}`)
                : setCenterText(`${props.min}-${props.max}`);
        }
    }, [props.value]);
    const handleOnChange = (value) => {
        if (value[0] === props.min && value[1] === props.max) {
            value = [];
        }
        props.onChange && props.onChange(props.id, Object.assign(Object.assign({}, props), { value }));
    };
    return (React.createElement("div", { style: { paddingLeft: '11px', width: '100%', paddingRight: '8px' } },
        React.createElement(RangeSlider, { id: props.id, value: props.value.length ? props.value : [props.min, props.max], srLabel: {
                mainLabel: 'Range slider',
                leftLabel: 'Decrease the amount',
                rightLabel: 'Increase the amount',
            }, topLabels: {
                left: (_b = props.topLabels) === null || _b === void 0 ? void 0 : _b.left,
                right: (_c = props.topLabels) === null || _c === void 0 ? void 0 : _c.right,
                center: centerText,
            }, min: props.min, max: props.max, increment: props.increment, onChange: val => handleOnChange(val) })));
};

const PickerWrapper = styled.div `
  width: 100%;
`;
class PickerFilter extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnChange = (event, items) => {
            const selectedValue = event.target.value;
            const findObj = items.find((item) => item === selectedValue);
            if (findObj) {
                const updated = items.filter((item) => item !== selectedValue);
                this.props.onChange(this.props.id, Object.assign(Object.assign({}, this.pickerFilter), { value: updated }));
            }
            else {
                this.props.onChange(this.props.id, Object.assign(Object.assign({}, this.pickerFilter), { value: [...this.pickerFilter.value, selectedValue] }));
            }
        };
    }
    get pickerFilter() {
        return {
            title: this.props.title,
            id: this.props.id,
            items: this.props.items,
            value: this.props.value,
            type: 'picker',
            layout: this.props.layout,
        };
    }
    render() {
        return (React.createElement(PickerWrapper, null,
            React.createElement(Picker, { id: this.props.id, onChange: event => {
                    this.handleOnChange(event, this.props.value);
                }, selected: this.props.value, label: 'Checkboxes example', items: this.props.items, columns: this.props.layout })));
    }
}

class ColorPickerFilter extends PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnChange = (event, items) => {
            const selectedValue = event.target.value;
            const findObj = items.find((item) => item === selectedValue);
            if (findObj) {
                const updated = items.filter((item) => item !== selectedValue);
                this.props.onChange(this.props.id, Object.assign(Object.assign({}, this.colorPickerFilter), { value: updated }));
            }
            else {
                this.props.onChange(this.props.id, Object.assign(Object.assign({}, this.colorPickerFilter), { value: [...this.colorPickerFilter.value, selectedValue] }));
            }
        };
    }
    get colorPickerFilter() {
        return {
            title: this.props.title,
            id: this.props.id,
            items: this.props.items,
            value: this.props.value,
            type: 'color-picker',
            layout: this.props.layout,
        };
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(ColorPicker, { id: this.props.id, onChange: event => {
                    this.handleOnChange(event, this.props.value);
                }, selected: this.props.value, label: 'Checkboxes example', items: this.props.items, columns: this.props.layout })));
    }
}

const RangeSliderWithToggleFilter = props => {
    var _a, _b, _c;
    const [active, setActive] = useState(false);
    const [centerText, setCenterText] = useState(((_a = props.value) === null || _a === void 0 ? void 0 : _a.length) ? `${props.value[0]}-${props.value[1]}` : `${props.min}-${props.max}`);
    useEffect(() => {
        var _a;
        {
            ((_a = props.value) === null || _a === void 0 ? void 0 : _a.length)
                ? setCenterText(`${props.value[0]}-${props.value[1]}`)
                : setCenterText(`${props.min}-${props.max}`);
        }
    }, [props.value]);
    useEffect(() => {
        props.onChange && props.onChange(props.id, Object.assign(Object.assign({}, props), { value: [] }));
    }, [active]);
    const handleOnChange = (value) => {
        if ((value[0] === props.min && value[1] === props.max) || !active) {
            value = [];
        }
        props.onChange && props.onChange(props.id, Object.assign(Object.assign({}, props), { value }));
    };
    return (React.createElement(GridRow, { noGutters: true, justify: "between", align: "center" },
        React.createElement(Span, null, props.activeText),
        React.createElement(Toggle, { id: "default-toggle", name: "the-default-toggle", value: "toggle-1", isActive: active, showIcons: false, onChange: () => {
                setActive(!active);
            } }),
        active && (React.createElement("div", { style: { paddingLeft: '11px', width: '100%', paddingRight: '8px' } },
            React.createElement(RangeSlider, { id: props.id, value: props.value.length ? props.value : [props.min, props.max], srLabel: {
                    mainLabel: 'Range slider with toggle',
                    leftLabel: 'Decrease the amount',
                    rightLabel: 'Increase the amount',
                }, topLabels: {
                    left: (_b = props.topLabels) === null || _b === void 0 ? void 0 : _b.left,
                    right: (_c = props.topLabels) === null || _c === void 0 ? void 0 : _c.right,
                    center: centerText,
                }, min: props.min, max: props.max, increment: props.increment, onChange: val => handleOnChange(val) })))));
};

const ModalContent$1 = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const WrapperColl = styled.div `
  margin-left: 3px;
  & div {
    font-weight: normal;
  }
`;
const ScrollWrapper = styled.div `
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 8px !important;
    height: 7px !important;
    border-raduis: 50% !important;
  }

  &::-webkit-scrollbar-thumb {
    background: #f2f2f2 !important;
    border-radius: 20px !important;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1) !important;
  }

  flex-grow: 1;
  & > div {
    padding: 4px 12px 0 0;
  }
`;
const ButtonsContainer = styled.div `
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-top: 2px solid #f2f2f2;
  margin: 0;
  padding: 0;
`;
const RenderFilterBasedOnType = ({ filter, index, onChange }) => {
    switch (filter.type) {
        case 'radio':
            return (React.createElement(GridRow, null,
                React.createElement(GridColumn, { col: 12 },
                    React.createElement(RadioFilter, { type: filter.type, key: index, title: filter.title, id: filter.id, value: filter.value, items: filter.items, onChange: onChange }))));
        case 'toggle':
            return (React.createElement(GridRow, { noGutters: true },
                React.createElement(GridColumn, { col: 12 },
                    React.createElement(GridRow, { noGutters: true, justify: "between", align: "center" },
                        React.createElement(Span, null, filter.items[0].label),
                        React.createElement(ToggleFilter, { key: index, title: filter.title, id: filter.id, items: filter.items, onChange: onChange })))));
        case 'range-slider':
            return (React.createElement(GridRow, { noGutters: true },
                React.createElement(GridColumn, { col: 12 },
                    React.createElement(RangeSliderFilter, { type: filter.type, title: filter.title, id: filter.id, value: filter.value, topLabels: filter.topLabels, min: filter.min, max: filter.max, increment: filter.increment, onChange: onChange }))));
        case 'range-slider-with-toggle':
            return (React.createElement(GridRow, { noGutters: true },
                React.createElement(GridColumn, { col: 12 },
                    React.createElement(RangeSliderWithToggleFilter, { type: filter.type, title: filter.title, id: filter.id, value: filter.value, topLabels: filter.topLabels, min: filter.min, max: filter.max, increment: filter.increment, onChange: onChange, activeText: filter.activeText }))));
        case 'picker':
            return (React.createElement(GridRow, { noGutters: true },
                React.createElement(GridColumn, { col: 12 },
                    React.createElement(PickerFilter, { title: filter.title, id: filter.id, onChange: onChange, items: filter.items, value: filter.value, layout: filter.layout }))));
        case 'color-picker':
            return (React.createElement(GridRow, { noGutters: true },
                React.createElement(GridColumn, { col: 12 },
                    React.createElement(ColorPickerFilter, { title: filter.title, id: filter.id, onChange: onChange, items: filter.items, value: filter.value, layout: filter.layout }))));
        default:
            return null;
    }
};
const Filter = ({ isOpen, title, filters, onClose, onClear, onConfirm, confirmButtonText, clearButtonText, }) => {
    const [filtersState, setFiltersState] = useState(filters);
    useEffect(() => {
        setFiltersState(filters);
    }, [filters]);
    const handleOnChange = (id, updatedFilter) => {
        const updatedFilters = filtersState.map(filter => {
            if (id === filter.id)
                return Object.assign({}, updatedFilter);
            return filter;
        });
        setFiltersState(updatedFilters);
    };
    return (React.createElement(Modal, { srName: "Filters", isOpen: isOpen, size: 4, type: "flyout", side: "left", isClosable: true, onCloseCb: onClose },
        React.createElement(ModalContent$1, { style: { display: 'flex', flexDirection: 'column', height: '100%' } },
            title && (React.createElement(GridRow, { noGutters: true, marginBottom: 4, justify: "start" },
                React.createElement(Paragraph, { size: 2, weight: 3 }, title))),
            React.createElement(ScrollWrapper, null,
                React.createElement(Accordion, { initiallyOpenIds: ['0'], appearance: "primary", level: 2, multi: true }, filtersState.map((filter, index) => (React.createElement(Fragment, { key: index },
                    React.createElement(CollapsibleContainer, { id: filter.id },
                        React.createElement(WrapperColl, null,
                            React.createElement(CollapsibleContainerHeader, null, filter.title)),
                        React.createElement(Spacing, { spacingLevel: { top: 4, left: 1 } },
                            React.createElement(CollapsibleContainerBody, null,
                                React.createElement(RenderFilterBasedOnType, { filter: filter, index: index, onChange: handleOnChange })))),
                    React.createElement(Spacing, { spacingLevel: { top: 4, bottom: 4 } }, index != filtersState.length - 1 && React.createElement(Divider, { appearance: "secondary" }))))))),
            React.createElement(ButtonsContainer, null,
                React.createElement(Spacing, { spacingLevel: { top: 8 } },
                    React.createElement(GridRow, { noGutters: true },
                        React.createElement(Button, { text: confirmButtonText, appearance: "primary", width: "full", onClick: () => onConfirm(filtersState) }))),
                React.createElement(Spacing, { spacingLevel: { top: 4 } },
                    React.createElement(GridRow, { noGutters: true },
                        React.createElement(Button, { text: clearButtonText, appearance: "alt1", width: "full", onClick: () => onClear() })))))));
};

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$1(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$1(_objectSpread$1({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);

  if (!matched) {
    var ki = key.indexOf(keySeparator);

    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }

  return matched;
}

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;

  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;

    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }

    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];

      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }

      if (mix === undefined) return undefined;
      if (mix === null) return null;

      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }

      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }

    current = current[paths[i]];
  }

  return current;
}

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  var _super = _createSuper(ResourceStore);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1$1(_objectSpread$1$1({}, pack), resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1$1(_objectSpread$1$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  var _super = _createSuper$1(Translator);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };

      if (key === undefined || key === null) {
        return false;
      }

      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);

      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof$1(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;

          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }

          return "".concat(namespace).concat(nsSeparator).concat(key);
        }

        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }

          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2(_objectSpread$2({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");

          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }

          return r;
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2(_objectSpread$2({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2(_objectSpread$2({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;

            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);

        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }

      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2(_objectSpread$2({}, options), {
          interpolation: _objectSpread$2(_objectSpread$2({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2(_objectSpread$2({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();

        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");

              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);

                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }

              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);

                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);

                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');

    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }

    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }

      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }

      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);

      if (!rule) {
        return [];
      }

      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);

      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }

        return this.getSuffixRetroCompatible(rule, count);
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }

      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);

  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);

          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }

          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$3({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);

        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;

        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);

        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];

    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }

    return formatter(val);
  };
}

var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Formatter);

    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, options);
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$4(_objectSpread$4({}, options), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val, options.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, options) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$4({}, options));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }

  _createClass(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;

      var formats = _format.split(this.formatSeparator);

      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;

        if (_this.formats[formatName]) {
          var formatted = mem;

          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }

          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }

        return mem;
      }, value);
      return result;
    }
  }]);

  return Formatter;
}();

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  var _super = _createSuper$2(Connector);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });

      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);

        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];

            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});

      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }

      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        _this3.readingCalls--;

        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();

          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }

        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5(_objectSpread$5({}, options), {}, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof$1(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof$1(args[2]) === 'object' || _typeof$1(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function noop$2() {}

function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  var _super = _createSuper$3(I18n);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _super.call(this);

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized(_this));

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }

      var defOpts = get();
      this.options = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, defOpts), this.options), transformOptions(options));

      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6(_objectSpread$6({}, defOpts.interpolation), this.options.interpolation);
      }

      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }

      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var formatter;

        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });

        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }

        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$2;

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$2;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$2;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;

      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;

        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;

        _this4.setResolvedLanguage(l);
      };

      var done = function done(err, l) {
        if (l) {
          setLngProps(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof$1(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$2;

      var mergedOptions = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, this.options), options), {
        isClone: true
      });

      var clone = new I18n(mergedOptions);

      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }

      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);

  return I18n;
}(EventEmitter);

_defineProperty$1(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});

var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

instance.createInstance;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape
};
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}

var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
  }
};

const ContainerWrapper$1 = styled.div `
  display: flex;
  justify-content: center;
`;
const Img$2 = styled.img `
  width: 100%;
  height: 250px;
  object-fit: contain;
`;
const GalleryWithPreview = props => {
    const [isOpen, setIsOpen] = useState(false);
    const breakPoint = useBreakpoints();
    // TODO: to be added in pwa
    instance.use(initReactI18next).init({
        react: {
            useSuspense: false,
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(ContainerWrapper$1, null,
            React.createElement(Gallery, { maxWidth: "500px", thumbs: breakPoint.sm ? undefined : props.images, transitionSpeed: 600, srName: "" }, props.images.map((item, index) => (React.createElement("img", { key: `image${index}`, alt: item.altText, src: item.src, onClick: () => setIsOpen(true) }))))),
        React.createElement(Modal, { srName: "test-modal", isOpen: isOpen, size: 4, animate: true, isClosable: true, onCloseCb: () => {
                setIsOpen(false);
            } },
            React.createElement("div", { className: "example-wrapper", id: "vt-1", style: { width: '80%', margin: '0 auto', height: '100%' } },
                React.createElement(Heading, { justify: "center", size: 2 }, props.productName),
                React.createElement("div", null,
                    React.createElement(ContainerWrapper$1, null,
                        React.createElement(ImageCarousel, { srName: "", arrows: {
                                position: 'outside',
                            }, infiniteLoop: true, id: "carousel-one" }, props.images.map((item, index) => (React.createElement(Img$2, { key: `image${index}`, alt: item.altText, src: item.src }))))))))));
};

const defaultCardProps = {
    revertColors: true,
    cardWidth: '260px',
};

const CardWrapper$1 = styled.div `
  width: ${props => props.cardWidth};
  display: flex;
  flex: 1;
`;
const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const TopFeaturesWrapper = styled.div `
  flex: 1;
`;
const GenericUpSellingCard = ({ id, title, topFeaturesList, cardLabel, viewMoreText, paymentData, addToCartCTA, removeFromCartCTA, maxFeatures, revertColors, cardWidth, isSelected, onViewMore, }) => {
    const renderTopFeaturesList = () => {
        return topFeaturesList.slice(0, maxFeatures).map(item => (React.createElement(SimpleGrid, { layout: {
                sm: [2, 10],
            }, verticalAlign: "center", key: id, spacing: 1 },
            React.createElement(Icon, { name: "tick", state: "error" }),
            React.createElement(Paragraph, { size: 2 }, item))));
    };
    const renderPaymentOptions = () => {
        return paymentData.map(payment => {
            return payment.label ? (payment.label) : (React.createElement(React.Fragment, null,
                React.createElement(Heading, { size: 1, weight: 4 },
                    payment.price.value,
                    payment.price.unit,
                    "\u00A0"),
                "/\u00A0",
                payment.duration.unit));
        });
    };
    const checkAppearance = () => {
        if (revertColors) {
            return isSelected ? 'primary' : 'secondary';
        }
        else {
            return isSelected ? 'secondary' : 'primary';
        }
    };
    return (React.createElement(CardWrapper$1, { cardWidth: cardWidth },
        React.createElement(ContainerWithLabel, { label: cardLabel, appearance: "secondary" },
            React.createElement(ContentContainer, null,
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 2 },
                    React.createElement(Heading, { size: 1, weight: 3, text: title })),
                React.createElement(TopFeaturesWrapper, null,
                    React.createElement(SimpleGrid, { spacing: 1, columns: { sm: 1 } }, renderTopFeaturesList())),
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginTop: 2 },
                    React.createElement(Link, { onClick: onViewMore, text: viewMoreText, showUnderline: true })),
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 4, marginTop: 2 }, renderPaymentOptions()),
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true },
                    React.createElement(Button, { width: "full", state: addToCartCTA.state, text: isSelected ? removeFromCartCTA.text : addToCartCTA.text, appearance: checkAppearance(), onClick: () => {
                            isSelected ? removeFromCartCTA.action(id) : addToCartCTA.action(id);
                        } }))))));
};
GenericUpSellingCard.defaultProps = defaultCardProps;

const GiftContainer = styled.div `
  padding: 10px;
  display: flex;
  gap: 10px;
  background-color: #f4f4f4;
  border-radius: ${props => props.borderRadius}px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  & p {
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
const GiftText = styled.p `
  margin: 0;
  font-size: 18px;
  line-height: 26px;
  -webkit-letter-spacing: 0;
  -moz-letter-spacing: 0;
  -ms-letter-spacing: 0;
  letter-spacing: 0;
  font-weight: 400;
  font-family: Vodafone, Open Sans, sans-serif;
  -webkit-font-smoothing: antialiased;
`;
const HighlightedText = styled.span `
  margin: 0;
  font-size: 18px;
  line-height: 26px;
  -webkit-letter-spacing: 0;
  -moz-letter-spacing: 0;
  -ms-letter-spacing: 0;
  letter-spacing: 0;
  font-weight: 700;
  font-family: Vodafone, Open Sans, sans-serif;
  -webkit-font-smoothing: antialiased;
`;
const Gift = props => {
    var _a, _b, _c, _d;
    const positionOfHighlightedText = props.highlightedText
        ? (_a = props.text) === null || _a === void 0 ? void 0 : _a.search(props.highlightedText)
        : -1;
    const textBeforeHighlightedText = (_b = props.text) === null || _b === void 0 ? void 0 : _b.substring(0, positionOfHighlightedText);
    const textAfterHighlightedText = (_c = props.text) === null || _c === void 0 ? void 0 : _c.substring(positionOfHighlightedText + (props.highlightedText ? (_d = props.highlightedText) === null || _d === void 0 ? void 0 : _d.length : 0));
    return (React.createElement(GiftContainer, { id: `${props.id || ''}-gift-container`, borderRadius: props.borderRadius },
        React.createElement(CommonIcon, { iconTopMargin: props.iconMarginTop, src: props.icon || { name: 'store-offer', group: 'system' } }),
        props.highlightedText && props.text ? (React.createElement(GiftText, null,
            textBeforeHighlightedText,
            React.createElement(HighlightedText, null, props.highlightedText),
            textAfterHighlightedText)) : (React.createElement(Paragraph, null, props.text))));
};
Gift.defaultProps = {
    borderRadius: 6,
    iconMarginTop: 0,
};

const StyledImageContainer = styled.div `
  padding: 5px;
`;
const StyledTextContainer = styled.div `
  padding: 2px;
`;
const StyledGrid = styled.div `
  & span:nth-of-type(1) {
    align-self: baseline;
    display: block;
    margin-bottom: 5px;
  }

  & span:nth-of-type(2) {
    padding: unset;
    text-align: unset;
  }
`;
const ImagePickerItem = ({ selected, groupName, inverse = false, onChange, items, columns, }) => {
    const defaultColumns = {
        sm: items.length <= 3 ? items.length : 3,
    };
    const pickerType = Array.isArray(selected) ? 'checkbox' : 'radio';
    return (React.createElement(SimpleGrid, { columns: Object.assign(Object.assign({}, defaultColumns), columns), spacing: 2, verticalAlign: "stretch" }, items === null || items === void 0 ? void 0 : items.map((pickerItem, index) => {
        var _a, _b;
        const isSelected = pickerType === 'radio'
            ? selected === pickerItem.value
            : selected.includes(pickerItem.value);
        return (React.createElement(StyledGrid, null,
            React.createElement(FunctionalPickerItem, { groupName: groupName, inverse: inverse, type: pickerType, onChange: onChange, value: pickerItem.value, id: pickerItem.id, state: pickerItem.state, key: index, srText: pickerItem.srText, checked: isSelected },
                React.createElement(StyledImageContainer, null,
                    React.createElement(Image, { key: `${pickerItem.id + groupName}`, alt: (_a = pickerItem.image) === null || _a === void 0 ? void 0 : _a.alt, roundedCorners: true, sm: {
                            src: (_b = pickerItem.image) === null || _b === void 0 ? void 0 : _b.src,
                        } })),
                React.createElement(StyledTextContainer, null,
                    React.createElement(Spacing, { spacingLevel: { top: 3 } },
                        React.createElement(Paragraph, { weight: 2, size: 2 }, pickerItem.title))))));
    })));
};

const defaultProps$1 = {
    imageHeight: 320,
    imageWidth: 465,
};
const CardContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
`;
const ImageAndTextContainer = styled.div ``;
const ImageContainer = styled.div `
  border-radius: 6px;
  overflow: hidden;
`;
const HeaderContainer = styled.div `
  padding: 20px;
`;
const ButtonContainer = styled.div `
  width: 295px;
`;
const ImagePlanCard = exposedProps => {
    const props = Object.assign(Object.assign({}, defaultProps$1), exposedProps);
    return (React.createElement(Card, Object.assign({ width: 505, height: 672 }, props.cardProps),
        React.createElement(CardContentContainer, null,
            React.createElement(ImageAndTextContainer, null,
                React.createElement(ImageContainer, null,
                    React.createElement(Image, { sm: {
                            src: props.imageSrc,
                            width: props.imageWidth,
                            height: props.imageHeight,
                        } })),
                React.createElement(HeaderContainer, null,
                    React.createElement(Heading, { noMargin: true, justify: "center", text: props.headerText, size: 3 })),
                React.createElement(Paragraph, { justify: "center" }, props.paragraphText)),
            React.createElement(ButtonContainer, null,
                React.createElement(TileButton, { id: props.id, showLink: props.showLink, showButton: true, link: props.link, linkText: props.linkText, padding: 20, buttonText: props.buttonText, onClick: props.onClick })))));
};
ImagePlanCard.defaultProps = defaultProps$1;

const GapContainer = props => {
    const ref = useRef(null);
    useEffect(() => {
        const handleResize = () => {
            const cellWidth = props.cellWidth + props.gap;
            if (ref && ref.current && ref.current.offsetWidth) {
                ref.current.style.width = 'fit-content';
                const elementWidth = ref.current.offsetWidth;
                const numberOfCardsPerRow = Math.floor((elementWidth - props.gap) / cellWidth);
                ref.current.style.width = `${cellWidth * numberOfCardsPerRow + props.gap}px`;
            }
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [props.gap, props.cellWidth]);
    return (React.createElement("div", { ref: ref, style: {
            maxWidth: props.maxWidth,
            display: 'flex',
            flexWrap: 'wrap',
            gap: props.gap,
            padding: `0px ${props.gap}px`,
            justifyContent: 'flex-start',
        } }, props.children));
};

const CardListingContainer = styled.div `
  display: flex;
  box-sizing: border-box;
  justify-content: center;
`;
const defaultProps = {
    distanceBetweenCards: 20,
    numberOfCards: 2,
    cardWidth: 505,
};
const ImagePlanCardListing = exposedProps => {
    const props = Object.assign(Object.assign({}, defaultProps), exposedProps);
    return (React.createElement(CardListingContainer, null,
        React.createElement(GapContainer, { maxWidth: props.distanceBetweenCards * (props.numberOfCards + 1) +
                props.numberOfCards * props.cardWidth, gap: props.distanceBetweenCards, cellWidth: props.cardWidth }, props.plans.map((imagePlanCardProps, index) => (React.createElement("div", { key: `card-${index}`, id: `card-${index}` },
            React.createElement(ImagePlanCard, Object.assign({}, imagePlanCardProps))))))));
};
ImagePlanCardListing.defaultProps = defaultProps;

const defaultModalContentProps = {
    headerMarginBottom: 7,
    iconMarginBottom: 7,
    titleMarginBottom: 4,
    pickerMarginBottom: 0,
};

const ModalContent = ({ header, headerMarginBottom, icon, iconMarginBottom, title, titleTestId, titleMarginBottom, picker, pickerMarginBottom, primaryButton, secondaryButton, subtitles, }) => {
    const renderSubs = subtitles === null || subtitles === void 0 ? void 0 : subtitles.map((sub, i) => (sub.regular || sub.bold) && (React.createElement(GridRow, { key: i, justify: "center", align: "center", marginBottom: sub.marginBottom || 0 },
        React.createElement(Paragraph, { size: 2, weight: 2, justify: "center", noMargin: true, dataAttributes: { 'data-testid': sub.regularTestId } },
            sub.regular || '',
            React.createElement(Span, { weight: 3, dataAttributes: { 'data-testid': sub.boldTestId } }, sub.bold || '')))));
    return (React.createElement(React.Fragment, null,
        header && (React.createElement(GridRow, { justify: "center", align: "center", marginBottom: headerMarginBottom },
            React.createElement(Paragraph, { size: 2, weight: 3, justify: "center", noMargin: true }, header))),
        icon && (React.createElement(GridRow, { align: "center", justify: "center", marginBottom: iconMarginBottom, noGutters: true },
            React.createElement(GridColumn, { col: 'auto' },
                React.createElement(Icon, { name: icon, group: "hifiLight", size: 4 })))),
        React.createElement(GridRow, { align: "center", justify: "center", marginBottom: titleMarginBottom, noGutters: true },
            React.createElement(GridColumn, null,
                React.createElement(Heading, { size: 2, weight: 3, justify: "center", noMargin: true, dataAttributes: { 'data-testid': titleTestId } }, title))),
        subtitles && renderSubs,
        picker && (React.createElement(GridRow, { noGutters: true, justify: "center", align: "center", marginBottom: pickerMarginBottom },
            React.createElement(GridColumn, { col: 10, colMd: 9 },
                React.createElement(Picker, { items: picker.items, selected: picker.selected, onChange: picker.onChange, groupName: 'Radio', label: 'Payment methods picker', dataSelectorPrefix: 'payment-methods-picker' })))),
        (primaryButton || secondaryButton) && (React.createElement(GridRow, { align: "center", justify: "center", noGutters: true },
            React.createElement(GridColumn, { col: 10, colMd: 6 },
                primaryButton && (React.createElement(GridRow, { marginBottom: secondaryButton ? 4 : 0, noGutters: true },
                    React.createElement(Button, { width: "full", text: primaryButton.text, appearance: primaryButton.appearance || 'primary', onClick: primaryButton.onClick, state: primaryButton.state || '', dataAttributes: {
                            'data-testid': primaryButton.dataTestId,
                        } }))),
                secondaryButton && (React.createElement(GridRow, { noGutters: true },
                    React.createElement(Button, { width: "full", text: secondaryButton.text, appearance: secondaryButton.appearance || 'alt1', onClick: secondaryButton.onClick, state: secondaryButton.state || '', dataAttributes: {
                            'data-testid': secondaryButton.dataTestId,
                        } }))))))));
};
ModalContent.defaultProps = defaultModalContentProps;

const SCREENS = {
    loading: 'LOADING',
    confirmation: 'CONFIRMATION',
    success: 'SUCCESS',
    lowBalance: 'LOW_BALANCE',
    genericError: 'GENERIC_ERROR'
};

const Confirmation = ({ mainConfirmationMessage, subConfirmationMessage, duration, priceText, currentBalanceText, button, testIds, }) => (React.createElement(React.Fragment, null,
    React.createElement(GridRow, { justify: "center", marginTop: 4, marginBottom: 4, noGutters: true },
        React.createElement(GridColumn, { col: 10, colMd: 8 },
            React.createElement(Heading, { size: 2, justify: "center", weight: 3, dataAttributes: { 'data-testid': testIds.mainConfirmationMessage }, noMargin: true }, mainConfirmationMessage))),
    React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
        React.createElement(Paragraph, { weight: 2, justify: "center", dataAttributes: { 'data-testid': testIds.subConfirmationMessage }, noMargin: true }, subConfirmationMessage)),
    React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
        React.createElement(Icon, { name: duration.icon, group: "system", dataAttributes: { 'data-testid': testIds.durationIcon } }),
        React.createElement(Spacing, { spacingLevel: {
                left: 2,
            } },
            React.createElement(Paragraph, { justify: "center", weight: 2, noMargin: true, dataAttributes: { 'data-testid': testIds.durationText } }, duration.text))),
    React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
        React.createElement(Paragraph, { justify: "center", weight: 3, dataAttributes: { 'data-testid': testIds.price }, noMargin: true }, priceText)),
    currentBalanceText && (React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
        React.createElement(Paragraph, { weight: 2, justify: "center", dataAttributes: { 'data-testid': testIds.currentBalance }, noMargin: true }, currentBalanceText))),
    React.createElement(GridRow, { justify: "center", noGutters: true },
        React.createElement(Button, { width: "full", text: button.text, onClick: button.action, dataAttributes: {
                'data-testid': testIds.button,
            } }))));

const Wrapper$1 = styled.div `
  margin: auto;
`;
const Loading = ({ text, testIds }) => (React.createElement(Wrapper$1, null,
    React.createElement(Loader, { text: text, size: 2, srText: text, dataAttributes: { 'data-testid': testIds === null || testIds === void 0 ? void 0 : testIds.loader } })));

const Success = ({ successIcon, mainSuccessMessage, subSuccessMessage, duration, remainingBalance, button, testIds, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 4 },
            React.createElement(Icon, { name: successIcon, group: "hifiLight", size: 3, dataAttributes: { 'data-testid': testIds.successIcon } })),
        React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
            React.createElement(Heading, { size: 2, justify: "center", weight: 3, dataAttributes: { 'data-testid': testIds.mainSuccessMessage }, noMargin: true }, mainSuccessMessage)),
        React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
            React.createElement(Paragraph, { justify: "center", weight: 2, dataAttributes: { 'data-testid': testIds.subSuccessMessage }, noMargin: true }, subSuccessMessage)),
        React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
            React.createElement(Icon, { name: duration.icon, group: "system", dataAttributes: { 'data-testid': testIds.durationIcon } }),
            React.createElement(Spacing, { spacingLevel: {
                    left: 2,
                } },
                React.createElement(Paragraph, { justify: "center", noMargin: true, weight: 2, dataAttributes: { 'data-testid': testIds.durationText } }, duration.text))),
        remainingBalance && (React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
            React.createElement(Paragraph, { noMargin: true, justify: "center", dataAttributes: { 'data-testid': testIds.remainingBalance }, weight: 2 }, remainingBalance))),
        React.createElement(GridRow, { justify: "center", noGutters: true },
            React.createElement(Button, { width: "full", text: button.text, onClick: button.action, dataAttributes: {
                    'data-testid': testIds.button,
                } }))));
};

const LowBalance = ({ lowBalanceIcon, mainErrorMessage, subErrorMessage, availableBalanceMessage, requiredBalanceMessage, button, testIds, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 4 },
            React.createElement(Icon, { name: lowBalanceIcon, group: "hifiLight", size: 3, dataAttributes: { 'data-testid': testIds.lowBalanceIcon } })),
        React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
            React.createElement(Heading, { size: 2, justify: "center", weight: 3, dataAttributes: { 'data-testid': testIds.mainErrorMessage }, noMargin: true }, mainErrorMessage)),
        React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
            React.createElement(Paragraph, { justify: "center", weight: 2, dataAttributes: { 'data-testid': testIds.subErrorMessage }, noMargin: true }, subErrorMessage)),
        availableBalanceMessage && (React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
            React.createElement(Paragraph, { justify: "center", weight: 2, dataAttributes: { 'data-testid': testIds.availableBalanceMessage }, noMargin: true }, availableBalanceMessage))),
        React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
            React.createElement(Paragraph, { justify: "center", weight: 3, dataAttributes: { 'data-testid': testIds.requiredBalanceMessage }, noMargin: true }, requiredBalanceMessage)),
        React.createElement(GridRow, { justify: "center", noGutters: true },
            React.createElement(Button, { width: "full", text: button.text, onClick: button.action, dataAttributes: {
                    'data-testid': testIds.button,
                } }))));
};

const GenericError = ({ genericErrorIcon, mainErrorMessage, subErrorMessage, thirdErrorMessage, fourthErrorMessage, button, testIds, }) => (React.createElement(React.Fragment, null,
    React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 4 },
        React.createElement(Icon, { name: genericErrorIcon, group: "hifiLight", size: 3, dataAttributes: { 'data-testid': testIds.genericErrorIcon } })),
    React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
        React.createElement(Heading, { size: 2, justify: "center", weight: 3, dataAttributes: { 'data-testid': testIds.mainErrorMessage } }, mainErrorMessage)),
    React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
        React.createElement(Paragraph, { justify: "center", weight: 2, dataAttributes: { 'data-testid': testIds.subErrorMessage } }, subErrorMessage)),
    React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
        React.createElement(Paragraph, { justify: "center", weight: 2, dataAttributes: { 'data-testid': testIds.thirdErrorMessage } }, thirdErrorMessage)),
    React.createElement(GridRow, { justify: "center", marginBottom: 4, noGutters: true },
        React.createElement(Paragraph, { justify: "center", weight: 2, dataAttributes: { 'data-testid': testIds.fourthErrorMessage } }, fourthErrorMessage)),
    React.createElement(GridRow, { justify: "center", noGutters: true },
        React.createElement(Button, { width: "full", text: button.text, onClick: button.action, dataAttributes: {
                'data-testid': testIds.button,
            } }))));

const Box = styled.div `
  & .static {
    position: static;
  }
`;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 316px;
  ${Mixins.respondTo.md(css `
      min-height: 350px;
    `)}
`;
const OrderAndValidationModal = ({ screens, currentScreen, isModalOpen, setIsModalOpen, onCloseCb }) => {
    const renderScreens = (currentScreen) => {
        switch (currentScreen) {
            case SCREENS.loading:
                return React.createElement(Loading, Object.assign({}, screens.loading));
            case SCREENS.confirmation:
                return React.createElement(Confirmation, Object.assign({}, screens.confirmation));
            case SCREENS.success:
                return React.createElement(Success, Object.assign({}, screens.success));
            case SCREENS.lowBalance:
                return React.createElement(LowBalance, Object.assign({}, screens.lowBalance));
            case SCREENS.genericError:
                return React.createElement(GenericError, Object.assign({}, screens.genericError));
            default:
                return React.createElement("div", null, "NO SCREEN SELECTED");
        }
    };
    return (React.createElement(Modal, { srName: "payment", isOpen: isModalOpen, size: 2, animate: true, overlayBlur: true, isClosable: currentScreen !== SCREENS.loading, onCloseCb: () => {
            setIsModalOpen(false);
            onCloseCb ? onCloseCb() : '';
        }, fullScreenOnSM: true },
        React.createElement(Box, null,
            React.createElement(GridRow, { noGutters: true, justify: "center" },
                React.createElement(GridColumn, { col: 10, colMd: 8, colLg: 10, className: "static" },
                    React.createElement(Wrapper, null, renderScreens(currentScreen)))))));
};

const CardContainer = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  ${Mixins.spacing('gap', 4)};
`;
const HeadingInnerWrapper = styled.div `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const HeadingOuterWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 58px;
  ${Mixins.respondTo.md(css `
    min-height: 64px;
  `)}
`;
const CardHeader = styled.div `
  height: auto;
`;
const CardFooter = styled.div `
  margin-top: auto;
`;
const LinkContainer$2 = styled.div `
  text-align: center;
  ${Mixins.spacing('margin-top', 2)};
  & > button {
    color: ${props => props.theme.color.primary1.default} !important;
  }
`;
const addTestId$1 = (id) => (id ? { dataAttributes: { 'data-testid': id } } : {});
const PlanCard = props => {
    var _a, _b, _c, _d, _e, _f;
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const headingRef = useRef(null);
    useEffect(() => {
        if (headingRef === null || headingRef === void 0 ? void 0 : headingRef.current) {
            const { scrollHeight, offsetHeight } = headingRef.current;
            setIsTooltipVisible(scrollHeight > offsetHeight);
        }
    }, []);
    return (React.createElement(ContainerWithLabel, null,
        React.createElement(CardContainer, null,
            React.createElement(CardHeader, null,
                React.createElement(Container, { appearance: "alt2" },
                    React.createElement(HeadingOuterWrapper, null,
                        React.createElement(HeadingInnerWrapper, { "data-testid": "cardHeader", ref: headingRef }, isTooltipVisible ? (React.createElement(Tooltip, { size: 1, id: props.header, text: props.header, appearance: "secondary" },
                            React.createElement(Heading, Object.assign({ justify: "center", inverse: true, weight: 1, size: 2, text: props.header, noMargin: true }, addTestId$1((_a = props.testIds) === null || _a === void 0 ? void 0 : _a.header))))) : (React.createElement(Heading, Object.assign({ justify: "center", inverse: true, weight: 1, size: 2, text: props.header, noMargin: true }, addTestId$1((_b = props.testIds) === null || _b === void 0 ? void 0 : _b.header)))))))),
            props.description && (React.createElement(Paragraph, Object.assign({ noMargin: true }, addTestId$1((_c = props.testIds) === null || _c === void 0 ? void 0 : _c.description)), props.description)),
            React.createElement(CardFooter, null,
                React.createElement(Button, Object.assign({ appearance: (props.button.renderAppearance && props.button.renderAppearance(props.id)) || 'alt1', text: props.button.renderText(props.id), onClick: () => props.button.action(props.id), width: "full" }, addTestId$1((_d = props.testIds) === null || _d === void 0 ? void 0 : _d.button))),
                ((_e = props.link) === null || _e === void 0 ? void 0 : _e.text) && (React.createElement(LinkContainer$2, null,
                    React.createElement(Link, Object.assign({ text: props.link.text, onClick: () => props.link.action(props.id) }, addTestId$1((_f = props.testIds) === null || _f === void 0 ? void 0 : _f.link)))))))));
};

const PlanListing = props => {
    var _a;
    return (React.createElement(CardGrid, { cardsOnLoad: props.cardsOnLoad, gridLayoutSize: props.gridLayoutSize, showMoreCards: props.showMoreCards, items: (_a = props.plans) === null || _a === void 0 ? void 0 : _a.map(plan => {
            var _a;
            return (React.createElement(PlanCard, Object.assign({ key: plan.id }, plan, { button: {
                    renderText: props.button.renderText,
                    action: props.button.action,
                    renderAppearance: props.button.renderAppearance,
                } }, (((_a = props.link) === null || _a === void 0 ? void 0 : _a.text)
                ? {
                    link: {
                        text: props.link.text,
                        action: props.link.action,
                    },
                }
                : {}))));
        }) }));
};

const TextWrapper = styled.div `
  text-align: center;
  margin-top: 4px;
`;
const ProductCard = props => {
    return (React.createElement(Container, null,
        props.header,
        React.createElement(TextWrapper, null,
            React.createElement(Heading, { text: props.price.amount + ' ' + props.price.unit, size: 2, weight: 3 })),
        React.createElement(Divider, { appearance: "secondary" }),
        props.specifications.map(spec => {
            return (React.createElement(Spacing, { spacingLevel: { top: 1, bottom: 1 } },
                React.createElement(SimpleGrid, { spacing: 3, columns: { sm: 2 }, layout: { sm: [2, 10], md: [1, 11] }, verticalAlign: "center", justify: "left" },
                    React.createElement(Icon, { name: spec.icon, group: "system", size: 4 }),
                    React.createElement(Paragraph, { size: 2, weight: 2 }, spec.text))));
        }),
        React.createElement(Spacing, { spacingLevel: { top: 5, bottom: 2 } },
            React.createElement(TileButton, Object.assign({}, props === null || props === void 0 ? void 0 : props.tileButton)))));
};
ProductCard.defaultProps = {};

const StyledWrapper = styled.div `
  border-radius: ${props => props.borderRadius}px;
  overflow: hidden;
`;
const ProductSIMCard = props => {
    return (React.createElement(StyledWrapper, { borderRadius: props.borderRadius },
        React.createElement(Container, { enableOverlay: false, backgroundImage: {
                sm: {
                    src: props.backgroundImageURL,
                },
            } },
            React.createElement(SimpleGrid, { columns: { sm: 2 }, spacing: 3, layout: {
                    sm: [6, 6],
                    md: [9, 3],
                } },
                React.createElement(SimpleGrid, { columns: { sm: 1 }, spacing: 1, justify: 'left' },
                    React.createElement(Heading, { text: props.header, size: props.fontSizeMax ? 4 : 2, weight: 3, inverse: true }),
                    React.createElement(Paragraph, { size: props.fontSizeMax ? 2 : 1, weight: 1, inverse: true }, props.subHeader)),
                React.createElement(SimpleGrid, { spacing: 1, justify: "right" },
                    React.createElement(Icon, { name: props.icon, group: "hifiDark", size: 1 }))),
            React.createElement(Spacing, { spacingLevel: { top: 6 } },
                React.createElement(SimpleGrid, { columns: { sm: 2 }, spacing: 3, justify: "left", layout: {
                        sm: [5, 7],
                    } },
                    React.createElement(SimpleGrid, { columns: { sm: 1 }, justify: "left", spacing: 1 },
                        React.createElement(Paragraph, { size: props.fontSizeMax ? 2 : 1, weight: 1, inverse: true }, props.primaryFeature.type),
                        React.createElement(Heading, { text: props.primaryFeature.value + ' ' + props.primaryFeature.unit, weight: 3, size: props.fontSizeMax ? 4 : 2, inverse: true })),
                    props.secondaryFeature && (React.createElement(SimpleGrid, { columns: { sm: 1 }, spacing: 1 },
                        React.createElement(Paragraph, { size: props.fontSizeMax ? 2 : 1, weight: 1, inverse: true }, props.secondaryFeature.type),
                        React.createElement(Heading, { text: props.secondaryFeature.value + ' ' + props.secondaryFeature.unit, size: props.fontSizeMax ? 4 : 2, weight: 3, inverse: true }))))))));
};
ProductSIMCard.defaultProps = {};

const QuickFilterRadioList = props => {
    const [selected, setSelected] = useState('');
    const handleOnChange = (selectedValue) => {
        setSelected(selectedValue);
        props.onChange && props.onChange(selectedValue);
    };
    return (React.createElement(FilterList, { appearance: "primary", filterItems: props.items, label: 'quickFilters', selected: selected, onChange: e => handleOnChange(e.target.value), groupName: 'quickFilters', size: 1 }));
};

const QuickFilterCheckboxList = props => {
    const [selected, setSelected] = useState([]);
    const handleOnChange = (value) => {
        const findObj = selected.find(item => item === value);
        if (findObj) {
            const selectedValues = selected.filter(item => item !== value);
            setSelected(selectedValues);
            props.onChange && props.onChange(selectedValues);
        }
        else {
            const selectedValues = [...selected, value];
            setSelected(selectedValues);
            props.onChange && props.onChange(selectedValues);
        }
    };
    return (React.createElement(FilterList, { appearance: "primary", filterItems: props.items, label: 'quickFilters', onChange: e => handleOnChange(e.target.value), selected: selected, groupName: 'quickFilters', size: 1 }));
};

const QuickFilter = ({ isMulti, filter, onConfirm }) => {
    const handleOnChange = (updatedFilter) => {
        onConfirm(updatedFilter);
    };
    return (React.createElement(React.Fragment, null, isMulti ? (React.createElement(GridRow, { justify: "center", align: "center" },
        React.createElement(QuickFilterCheckboxList, { items: filter.items, groupName: filter.groupName, appearance: filter.appearance, id: filter.id, onChange: handleOnChange }))) : (React.createElement(GridRow, { justify: "center", align: "center" },
        React.createElement(QuickFilterRadioList, { items: filter.items, appearance: filter.appearance, id: filter.id, groupName: filter.groupName, onChange: handleOnChange })))));
};

const ContainerWrapper = styled.div `
  width: 100%;
  margin-top: 30px;
`;
const RedirectionPage = props => {
    var _a, _b, _c, _d;
    useBreakpoints();
    return (React.createElement(ContainerWrapper, null,
        React.createElement(SimpleGrid, { justify: "center", spacing: 0 },
            React.createElement("span", null,
                React.createElement(Icon, { name: props.icon.name, group: props.icon.group, size: 5 }))),
        React.createElement(Spacing, { spacingLevel: { top: 9 } },
            React.createElement(SimpleGrid, { spacing: 0, layout: { sm: [10], md: [12] }, justify: "center" },
                React.createElement(Heading, { size: 3, weight: 2, justify: "center" },
                    React.createElement("span", null, props.errorMessage)),
                React.createElement(Spacing, { spacingLevel: { top: 7, bottom: 7 } },
                    React.createElement(Heading, { size: 1, weight: 1, justify: "center" },
                        React.createElement("span", null, props.errorMessageDescription))))),
        React.createElement(SimpleGrid, { spacing: 0, layout: { sm: [12], md: [12], lg: [12] }, justify: "center" },
            props.buttonDefault && (React.createElement(SimpleGrid, { spacing: 0, layout: { sm: [12], md: [8], lg: [6] }, justify: "center" },
                React.createElement(Spacing, { spacingLevel: { bottom: 2 } },
                    React.createElement(Button, { appearance: "alt1", width: "full", text: (_a = props.buttonDefault) === null || _a === void 0 ? void 0 : _a.text, onClick: (_b = props.buttonDefault) === null || _b === void 0 ? void 0 : _b.onClick })))),
            props.buttonPrimary && (React.createElement(SimpleGrid, { spacing: 0, layout: { sm: [12], md: [8], lg: [6] }, justify: "center" },
                React.createElement(Spacing, { spacingLevel: {
                        top: 1,
                    } },
                    React.createElement(Button, { width: "full", text: (_c = props.buttonPrimary) === null || _c === void 0 ? void 0 : _c.text, onClick: (_d = props.buttonPrimary) === null || _d === void 0 ? void 0 : _d.onClick })))))));
};

const StickyDiv = styled.div `
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  position: sticky;
  left: 0;
  top: ${props => props.headerHeight || 0}px;
  width: 100%;
  height: fit-content;
  z-index: 5;
  opacity: ${props => (props.scrolled ? '1' : '0')};
  transition: opacity 0.5s ease-in-out;
  will-change: opacity;
`;
const StickyWrapper = ({ children }) => {
    const [headerHeight, setHeaderHeight] = useState(0);
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const Header = document.querySelector('.header');
        if (Header !== null)
            setHeaderHeight(Header.offsetHeight);
        const handleScroll = () => {
            if (window.pageYOffset === 0) {
                setScrolled(false);
            }
            else {
                setScrolled(true);
            }
        };
        const handleResize = () => {
            if (Header !== null)
                setHeaderHeight(Header.offsetHeight);
        };
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (React.createElement(React.Fragment, null, scrolled && (React.createElement(StickyDiv, { headerHeight: headerHeight, scrolled: scrolled }, children))));
};

const cardDefaultProps = {
    width: 330,
    fallBackImage: 'https://test.digitalretail.vodafone.com/static/media/image_not_found.543510b7.svg',
    nomOfDisplayedIndicators: 3,
};

const FlexBox = styled.div `
  display: flex;
  flex-wrap: ${props => { var _a; return (_a = props.wrap) !== null && _a !== void 0 ? _a : 'wrap'; }};
  align-items: ${props => { var _a; return (_a = props.align) !== null && _a !== void 0 ? _a : 'initial'; }};
  justify-content: ${props => { var _a; return (_a = props.justify) !== null && _a !== void 0 ? _a : 'initial'; }};
  flex-direction: ${props => { var _a; return (_a = props.direction) !== null && _a !== void 0 ? _a : 'initial'; }};
  gap: ${props => { var _a; return (_a = `${props.gap}px`) !== null && _a !== void 0 ? _a : 'initial'; }};
  margin-top: ${props => { var _a; return (_a = `${props.marginTop}px`) !== null && _a !== void 0 ? _a : 0; }};
  margin-bottom: ${props => { var _a; return (_a = `${props.marginBottom}px`) !== null && _a !== void 0 ? _a : 0; }};
`;
const FlexDiv = props => {
    return (React.createElement(FlexBox, { align: props.align, justify: props.justify, direction: props.direction, gap: props.gap, wrap: props.wrap, marginTop: props.marginTop, marginBottom: props.marginBottom }, props.children));
};

const ColorBox = styled.div(props => css `
    height: 30px;
    width: 30px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    ${props.selected &&
    css `
      border: 1px solid #000;
      pointer-events: none;
      cursor: default;
    `}
  `);
const ColorIndicator = ({ productVariations, currentVariation, onChangeColor, nomOfDisplayedIndicators }) => {
    const nomOfExtraIndicators = nomOfDisplayedIndicators < productVariations.length
        ? productVariations.length - nomOfDisplayedIndicators
        : 0;
    return (React.createElement(FlexDiv, { align: "center", justify: "center", gap: 12 },
        productVariations.slice(0, nomOfDisplayedIndicators).map(({ color, id }) => (React.createElement(ColorBox, { key: id, selected: currentVariation.color === color, onClick: () => onChangeColor(id) },
            React.createElement(ColorSwatch, { color: color, size: 3, theme: themeWS10 })))),
        !!nomOfExtraIndicators && React.createElement(Paragraph, { size: 2 },
            "+",
            nomOfExtraIndicators)));
};

const TileWrapper = styled.div(props => css `
    width: ${props.width}px;
  `);
const Img$1 = styled.img `
  width: 100%;
  height: 190px;
  object-fit: contain;
`;
const ProductNameContainer = styled.div `
  height: 56px;
  ${Mixins.respondTo.md(css `
      height: 64px;
    `)};
  & h2 {
    overflow: hidden;
    width: 100%;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
`;
const GiftReplacerDiv = styled.div `
  height: 40px;
  ${Mixins.respondTo.md(css `
      height: 44px;
    `)};
`;
const TangibleProductCard = ({ card, product }) => {
    var _a, _b;
    card = Object.assign(Object.assign({}, cardDefaultProps), card);
    const [currentVariation, setCurrentVariation] = useState(product.variations[0]);
    useEffect(() => {
        setCurrentVariation(product.variations[0]);
    }, [product]);
    const onChangeColor = (varId) => {
        setCurrentVariation(product.variations.find(({ id }) => id === varId) || product.variations[0]);
    };
    const renderStockIndicator = (indicator) => {
        var _a;
        const { color, text } = ((_a = card.stockIndicator) === null || _a === void 0 ? void 0 : _a.find(i => i.id === indicator)) || {};
        return (React.createElement(React.Fragment, null,
            React.createElement(ColorSwatch, { color: color, size: 1, theme: themeWS10 }),
            React.createElement(Span, null, text)));
    };
    return (React.createElement(TileWrapper, { width: card.width },
        React.createElement(ContainerWithLabel, { label: currentVariation.label || '', appearance: "secondary", paddingLevel: 3, allowOverflow: false, showOuterTopPadding: true },
            card.stockIndicator && (React.createElement(FlexDiv, { align: "center", justify: "flex-start", gap: 10, marginBottom: 30 }, renderStockIndicator(currentVariation.stockIndicator))),
            React.createElement(FlexDiv, { direction: "column", align: "center", justify: "center", gap: 20, marginBottom: 30 },
                React.createElement(Img$1, { src: currentVariation === null || currentVariation === void 0 ? void 0 : currentVariation.imageUrl, alt: product.name, onError: ({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = card.fallBackImage;
                    } }),
                React.createElement(ProductNameContainer, null,
                    React.createElement(Heading, { justify: "center", weight: 3, size: 2, text: product.name, noMargin: true })),
                React.createElement(ColorIndicator, { productVariations: product.variations, currentVariation: currentVariation, onChangeColor: onChangeColor, nomOfDisplayedIndicators: card.nomOfDisplayedIndicators })),
            card.gift &&
                (currentVariation.gift ? (React.createElement(Gift, { text: currentVariation.gift, icon: { name: card.gift.icon, group: card.gift.group } })) : (React.createElement(GiftReplacerDiv, null))),
            React.createElement(FlexDiv, { marginTop: 20, marginBottom: 20 },
                React.createElement(Divider, { noMargin: true })),
            React.createElement(FlexDiv, { align: "center", justify: "center", marginBottom: 20 },
                React.createElement(PriceOffering, { price: currentVariation.price.price, discountedPrice: currentVariation.price.discountedPrice, prefixText: (_a = card.price) === null || _a === void 0 ? void 0 : _a.prefixText, suffixText: (_b = card.price) === null || _b === void 0 ? void 0 : _b.suffixText, period: currentVariation.price.period })),
            card.tileButton && (React.createElement(Button, { text: card.tileButton.text, width: "full", appearance: "alt1", onClick: () => {
                    var _a;
                    if ((_a = card.tileButton) === null || _a === void 0 ? void 0 : _a.onClick)
                        card.tileButton.onClick(product.id, currentVariation.id);
                } })),
            card.compare && (React.createElement(Compare, { text: card.compare.text, onChange: isChecked => {
                    var _a;
                    if ((_a = card.compare) === null || _a === void 0 ? void 0 : _a.onChange)
                        card.compare.onChange(isChecked, product.id, currentVariation.id);
                } })))));
};

const TangibleProductListing = ({ card, products }) => {
    card = Object.assign(Object.assign({}, cardDefaultProps), card);
    return (React.createElement(FlexDiv, { justify: "center" },
        React.createElement(GapContainer, { maxWidth: 80 + 3 * card.width, gap: 20, cellWidth: card.width }, products.map((product, i) => (React.createElement(TangibleProductCard, { key: i, card: card, product: product }))))));
};

const currencyPosition = {
    EUR: 'el-GR',
    TRY: 'tr-TR',
    GBP: 'en-GB',
};
const formatByCountry = {
    EUR: {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    },
    TRY: {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
    },
    GBP: {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
    },
};
// Grab the formatting by country and validate it
function getFormatByCountry(country = 'EUR') {
    const defaultFormatSettings = {
        formatOptions: formatByCountry[country],
        currencyPosition: currencyPosition[country],
    };
    if (country.length !== 3) {
        return defaultFormatSettings;
    }
    return defaultFormatSettings;
}
// If  amount is String Convert it to valid Float
function normalizeInput(amount) {
    if (typeof amount === 'string')
        return parseFloat(amount.replace(',', '.')); // "123,32" -> 123.32
    return amount;
}
/**
 * Basic steps
 * IF 'amount' === STRING --> CONVERT IT TO FLOAT
 * Check if is a valid number
 * GET Locale Settings BY 'country'
 * Check for desired decimal
 */
function formatMoney(amount, country, avoidZeroDecimals = false) {
    const formattedAmountObject = {
        money: '',
        currencySymbol: '',
    };
    if (typeof country !== 'string') {
        formattedAmountObject.error = 'The country is not a valid input.';
        return formattedAmountObject;
    }
    const amountNumber = normalizeInput(amount);
    if (!isFinite(amountNumber) || typeof amountNumber !== 'number') {
        formattedAmountObject.error = 'The amount is not a valid input.';
        return formattedAmountObject;
    }
    const { formatOptions, currencyPosition } = getFormatByCountry(country || 'EUR');
    // Format the amount according to fetched locale settings
    let decimalSeparator = ',';
    Intl.NumberFormat(currencyPosition, formatOptions)
        .formatToParts(amountNumber)
        .map(({ type, value }) => {
        // Grab the parts of the formatted amount and assemble them in the final formatted money value & Money symbol
        if (type === 'minusSign')
            formattedAmountObject.money += value;
        if (type === 'integer' || type === 'group')
            formattedAmountObject.money += value;
        if (type === 'currency')
            formattedAmountObject.currencySymbol = value;
        if (type === 'decimal')
            decimalSeparator = value;
        if (type === 'fraction' && (!avoidZeroDecimals || value !== '00')) {
            formattedAmountObject.money += decimalSeparator;
            formattedAmountObject.money += value;
        }
    });
    return formattedAmountObject;
}

const Root = styled.div `
  & button#cta {
    width: 100%;
  }
`;
const HeadingWrapper = styled.div `
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const TopBar = props => {
    var _a, _b;
    const { money, currencySymbol } = formatMoney((_a = props.price) === null || _a === void 0 ? void 0 : _a.value, (_b = props.price) === null || _b === void 0 ? void 0 : _b.unit);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    const prefixRef = useRef(null);
    useEffect(() => {
        console.log('headingRef?.current', prefixRef);
        if (prefixRef === null || prefixRef === void 0 ? void 0 : prefixRef.current) {
            const { scrollHeight, offsetHeight } = prefixRef.current;
            setIsTooltipVisible(scrollHeight > offsetHeight);
        }
    }, []);
    return (React.createElement(Root, null,
        React.createElement(Container, { paddingLevel: 4 },
            React.createElement(Grid, null,
                React.createElement(GridRow, null,
                    React.createElement(GridColumn, null,
                        props.title && (React.createElement(GridRow, null,
                            props.title && (React.createElement(Paragraph, { size: 2, appearance: "secondary", noMargin: true }, props.title)),
                            props.price && (React.createElement(GridColumn, { autoMargin: "left", alignSelf: props.cta ? 'start' : 'center', alignSelfMd: "center" },
                                React.createElement(GridRow, { justify: "end" },
                                    React.createElement(Span, { weight: 3, appearance: "alt2" }, props.price.prefix),
                                    "\u00A0",
                                    React.createElement(Span, { appearance: "alt2" },
                                        money,
                                        currencySymbol)))),
                            props.cta && (React.createElement(MatchMedia, { breakpoint: "md", andAbove: true },
                                React.createElement(GridColumn, { colMd: 3, colLg: 2, autoMargin: "left", alignSelf: props.price ? 'center' : 'end' },
                                    React.createElement(SmallButton, { id: "cta", text: props.cta.text, onClick: props.cta.onClick, state: props.cta.state, loading: props.cta.loading })))))),
                        React.createElement(GridRow, null,
                            props.subTitle.icon && (React.createElement(LinkWithIcon, { appearance: "primary", text: props.subTitle.text, icon: {
                                    name: props.subTitle.icon.name,
                                    group: props.subTitle.icon.group,
                                    justify: 'right',
                                }, onClick: props.subTitle.onClick, to: props.subTitle.redirectURL, size: props.subTitle.size })),
                            props.subTitle.text.prefix && (React.createElement(React.Fragment, null,
                                props.useToolTipWithSubTitle ? (React.createElement(HeadingWrapper, { ref: prefixRef }, isTooltipVisible ? (React.createElement(Tooltip, { size: 1, text: props.subTitle.text.prefix, appearance: "secondary", id: props.subTitle.text.prefix },
                                    React.createElement(Heading, { noMargin: true, size: 2, weight: 2, text: props.subTitle.text.prefix }))) : (React.createElement(Heading, { noMargin: true, size: 2, weight: 2, text: props.subTitle.text.prefix })))) : (React.createElement(Heading, { noMargin: true, size: 2, weight: 2, text: props.subTitle.text.prefix })),
                                props.subTitle.text.suffix && (React.createElement(React.Fragment, null,
                                    React.createElement(Spacing, { spacingLevel: { left: 2, right: 2 } },
                                        React.createElement(Heading, { noMargin: true, size: 2, weight: 2, text: props.subTitle.text.separator })),
                                    React.createElement(Heading, { noMargin: true, size: 2, weight: 1, text: props.subTitle.text.suffix }))))),
                            props.cta && !props.title && (React.createElement(MatchMedia, { breakpoint: "md", andAbove: true },
                                React.createElement(GridColumn, { colMd: 3, colLg: 2, autoMargin: "left", alignSelf: props.price ? 'center' : 'end' },
                                    React.createElement(SmallButton, { id: "cta", text: props.cta.text, onClick: props.cta.onClick, state: props.cta.state, loading: props.cta.loading }))))))),
                props.cta && (React.createElement(MatchMedia, { breakpoint: "sm" },
                    React.createElement(GridRow, { marginTop: 4 },
                        React.createElement(SmallButton, { id: "cta", text: props.cta.text, onClick: props.cta.onClick, state: props.cta.state, loading: props.cta.loading }))))))));
};

const DetailsModal = ({ isOpen, setIsOpen, name, detailsList, paymentOptions, ProductActions, }) => (React.createElement(Modal, { animate: true, isOpen: isOpen, srName: "Details Modal", size: 5, onCloseCb: () => setIsOpen(false) },
    React.createElement(React.Fragment, null,
        React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 5 },
            React.createElement(Heading, { size: 2, text: name, weight: 2 })),
        detailsList.map((item, i) => (React.createElement(Paragraph, { key: i, justify: "center", size: 1 }, item))),
        React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 5, marginTop: 5 },
            React.createElement(GridColumn, { col: 12, colLg: 6 }, paymentOptions)),
        React.createElement(GridRow, { justify: "center", align: "center", noGutters: true },
            React.createElement(GridColumn, { col: 12, colLg: 6 }, ProductActions)))));

const FlexDivWrapper = styled.div `
  height: 125px;
  ${Mixins.respondTo.lg(css `
      height: 70px;
    `)};
`;
const LinkContainer$1 = styled.div `
  & button {
    color: ${props => props.theme.color.primary1.default};
  }
`;
const ImgWrapper = styled.div `
  height: 370px;
  background-color: #b40001;
  ${Mixins.respondTo.lg(css `
      height: 315px;
    `)};
`;
const Img = styled.img `
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const TrimedParagraph = styled.div `
  overflow: hidden;
  & p {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const PaymentWrapper = styled.div `
  min-height: 70px;
`;
const UpSellingCard = ({ id, imageUrl, name, type, topFeaturesList, paymentOptions, modalDetailsList, addProduct, removeProduct, cardDataAttributes, fallbackImageURL, detailsLinkText, disabled, isToggle, isLoading, selected, }) => {
    const mappedOptions = paymentOptions.map(option => ({
        title: option.label,
        value: option.type,
        state: '',
    }));
    const [isSelected, setIsSelected] = useState(selected);
    const [options, setOptions] = useState(mappedOptions);
    const [selectedPayment, setSelectedPayment] = useState(mappedOptions[0]);
    const [isOpen, setIsOpen] = useState(false);
    const breakPoints = useBreakpoints();
    useEffect(() => {
        if (isSelected) {
            const updatedOptions = options.map(option => {
                if (option.value === selectedPayment.value) {
                    option.state = '';
                    return option;
                }
                else {
                    option.state = 'disabled';
                    return option;
                }
            });
            setOptions(updatedOptions);
        }
        else {
            setOptions(options.map(option => {
                option.state = '';
                return option;
            }));
        }
    }, [isSelected]);
    const renderTopFeaturesList = topFeaturesList.map((item, i) => (React.createElement(FlexDiv, { align: "flex-start", gap: 8, wrap: "nowrap", key: i },
        React.createElement(Icon, { name: "tick", state: "success" }),
        React.createElement(TrimedParagraph, null,
            React.createElement(Paragraph, { size: 2 }, item)))));
    const renderProductActions = (React.createElement(Button, Object.assign({ loading: isLoading, width: "full", text: isSelected && isToggle ? removeProduct.text : addProduct.text, appearance: isSelected && isToggle ? 'secondary' : 'primary', onClick: () => {
            setIsSelected(!isSelected);
            isSelected && isToggle
                ? removeProduct.action(id)
                : addProduct.action({
                    id,
                    name,
                    type,
                    selectedPaymentOption: paymentOptions.find(option => option.type === selectedPayment.value),
                });
            setIsOpen(false);
        } }, (disabled && !isSelected && !isToggle ? { state: 'disabled' } : {}))));
    const renderPayment = options.length > 1 ? (React.createElement(Picker, { items: options, selected: selectedPayment.value, onChange: e => {
            const selOption = options.find(o => o.value === e.target.value);
            selOption && setSelectedPayment(selOption);
        }, label: 'payment options', groupName: 'payment', columns: { sm: 2, md: 2, lg: 2, xl: 2 } })) : (React.createElement(Heading, { justify: "center", text: options[0].title, size: 1, weight: 3, noMargin: true }));
    return (React.createElement(Container, { elevation: true, dataAttributes: cardDataAttributes },
        React.createElement(GridRow, { justify: "between", align: "stretch" },
            React.createElement(GridColumn, { marginBottom: breakPoints.sm ? 4 : 0, col: 12, colMd: 5 },
                React.createElement(ImgWrapper, null,
                    React.createElement(Img, { src: imageUrl, alt: name, onError: ({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src = fallbackImageURL;
                        } }))),
            React.createElement(GridColumn, { col: 12, colMd: 7 },
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 4 },
                    React.createElement(Heading, { size: 1, weight: 3, text: name })),
                React.createElement(FlexDivWrapper, null,
                    React.createElement(SimpleGrid, { spacing: 2, columns: { sm: 1, lg: 2 } }, renderTopFeaturesList)),
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 4, marginTop: 4 },
                    React.createElement(GridColumn, { col: 12, colLg: 10 },
                        React.createElement(PaymentWrapper, null, renderPayment))),
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true, marginBottom: 4 },
                    React.createElement(LinkContainer$1, null,
                        React.createElement(Link, { text: detailsLinkText, srText: "UpSelling Details Modal", onClick: () => setIsOpen(true) }))),
                React.createElement(GridRow, { justify: "center", align: "center", noGutters: true }, renderProductActions))),
        React.createElement(DetailsModal, { isOpen: isOpen, setIsOpen: setIsOpen, name: name, detailsList: modalDetailsList, paymentOptions: renderPayment, ProductActions: renderProductActions })));
};
UpSellingCard.defaultProps = {
    isToggle: true,
    isLoading: false,
    selected: false,
};

const CollapsibleContainerBodyWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-direction: column;
  width: 100%;
`;
const EditAmountInputWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  margin-bottom 5px;
`;
const TopUpAmount = ({ currency, header, pickerData, amountInput, isAmountInputVisible, isPickerVisible, isTopUpValueWithEditVisisble, taxMessage, netAmountMessage, topUpAmountMessage, topUpEditAmountMessage, editValueBtnClickHandler, onPickerValueChange, handleAmountInputChange, maxTopUpTextLength, }) => {
    const { pickerItems, pickerLabel, selectedValue } = pickerData;
    const { state, stateText, helperText, showTitle, showActionButton, actionButtonText, titleText, onClickActionButton, } = amountInput;
    function inputUpdateHandler(event) {
        const newValue = event.target.value;
        if (!newValue.match(currency)) {
            if (newValue.length === 1) {
                handleAmountInputChange(0);
            }
            else {
                handleAmountInputChange(newValue.substring(0, newValue.length - 1));
            }
        }
        else {
            handleAmountInputChange(newValue);
        }
    }
    return (React.createElement(Fragment, null,
        React.createElement(GridRow, { justify: "center", align: "center", marginBottom: 8, noGutters: true },
            React.createElement(GridColumn, null,
                React.createElement(Heading, { size: 1, text: header, weight: 2, justify: "center" }))),
        isTopUpValueWithEditVisisble && (React.createElement(GridRow, { justify: "center", align: "center", marginBottom: 8, noGutters: true },
            React.createElement(GridColumn, null,
                React.createElement(Fragment, null,
                    React.createElement(Paragraph, { size: 2, weight: 3, justify: "center", noMargin: true, dataAttributes: { 'data-testid': 'topUpValue' } }, `${topUpAmountMessage} ${currency}`),
                    React.createElement(EditAmountInputWrapper, null,
                        React.createElement(LinkWithIcon, { text: topUpEditAmountMessage, icon: {
                                name: 'edit',
                                justify: 'right',
                            }, onClick: editValueBtnClickHandler })))))),
        isPickerVisible && (React.createElement(GridRow, { justify: "center", align: "center", marginBottom: 8, noGutters: true },
            React.createElement(GridColumn, null,
                React.createElement(Picker, { label: pickerLabel, columns: { sm: 2 }, groupName: 'Radio', items: pickerItems, selected: selectedValue, onChange: onPickerValueChange, dataAttributes: {
                        'data-testid': 'amount-button',
                    }, dataSelectorPrefix: "amount-button" })))),
        isAmountInputVisible && (React.createElement(GridRow, { justify: "center", align: "center", marginTop: 3, marginBottom: 5, noGutters: true },
            React.createElement(GridColumn, null,
                React.createElement(CollapsibleContainerBodyWrapper, null,
                    showTitle && (React.createElement(Paragraph, { size: 2, weight: 3, justify: "center", noMargin: true, dataAttributes: { 'data-testid': 'topUpValue' } }, `${titleText}`)),
                    React.createElement(TextInputWithLabel, { state: state, fieldWrapper: {
                            label: '',
                            helpText: helperText,
                            stateText,
                            width: 'default',
                        }, textInput: {
                            id: 'amount-input',
                            maxLength: maxTopUpTextLength,
                            value: `${selectedValue}${currency}`,
                            placeholder: currency,
                            onChange: inputUpdateHandler,
                        }, dataAttributes: { 'data-testid': 'amount-input' } }),
                    showActionButton && (React.createElement(Button, { text: actionButtonText, state: state === 'error' ? 'disabled' : undefined, appearance: "primary", onClick: onClickActionButton })))))),
        React.createElement(GridRow, { justify: "center", align: "center", noGutters: true },
            React.createElement(GridColumn, null,
                React.createElement(Paragraph, { size: 2, weight: 2, justify: "center", dataAttributes: { 'data-testid': 'taxMessage' } }, taxMessage),
                React.createElement(Paragraph, { size: 2, weight: 3, justify: "center", noMargin: true, dataAttributes: { 'data-testid': 'netAmount' } }, `${netAmountMessage} ${currency}`)))));
};

const defaultPropsForCard = {
    width: 'auto',
};

const CardWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
const LinkContainer = styled.div `
  text-align: center;
  ${Mixins.spacing('margin-top', 2)};
  & > button {
    color: ${props => props.theme.color.primary1.default} !important;
  }
`;
const addTestId = (id) => (id ? { dataAttributes: { 'data-testid': id } } : {});
const AddonCard = props => {
    var _a, _b, _c, _d, _e, _f, _g;
    const cardProps = Object.assign(Object.assign({}, defaultPropsForCard), props === null || props === void 0 ? void 0 : props.card);
    const [toggleState, setToggleState] = useState(!!((_b = (_a = props.renewAndValidity) === null || _a === void 0 ? void 0 : _a.autoRenew) === null || _b === void 0 ? void 0 : _b.isActive));
    return (React.createElement(Card, Object.assign({}, cardProps),
        React.createElement(CardWrapper, null,
            React.createElement("div", null,
                React.createElement(CardHeader$1, Object.assign({}, props === null || props === void 0 ? void 0 : props.cardHeader)),
                (props === null || props === void 0 ? void 0 : props.priceOffering) && (React.createElement(React.Fragment, null,
                    React.createElement(PriceOffering, Object.assign({}, props === null || props === void 0 ? void 0 : props.priceOffering)),
                    React.createElement(Divider, { noMargin: true, appearance: "secondary" }))),
                props.cardBody && (React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                    } },
                    React.createElement(CardBody, Object.assign({}, props.cardBody, { isServicesIncludedVisible: !!((_d = (_c = props.servicesIncluded) === null || _c === void 0 ? void 0 : _c.icons) === null || _d === void 0 ? void 0 : _d.length) })))),
                !props.cardBody && (React.createElement(React.Fragment, null,
                    props.servicesIncluded && React.createElement(ServicesIncluded, Object.assign({}, props === null || props === void 0 ? void 0 : props.servicesIncluded)),
                    props.renewAndValidity && (React.createElement(React.Fragment, null,
                        React.createElement(Spacing, { spacingLevel: { top: 3, bottom: 3 } },
                            React.createElement(RenewAndValidity, Object.assign({}, props.renewAndValidity, { autoRenew: props.renewAndValidity.autoRenew && Object.assign(Object.assign({}, props.renewAndValidity.autoRenew), { isActive: toggleState }), onChangeToggle: state => {
                                    var _a, _b;
                                    if ((_a = props.renewAndValidity) === null || _a === void 0 ? void 0 : _a.onChangeToggle) {
                                        (_b = props.renewAndValidity) === null || _b === void 0 ? void 0 : _b.onChangeToggle(state, props.id);
                                    }
                                    setToggleState(state);
                                } }))))),
                    props.consumption && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, { noMargin: true, appearance: "secondary" }),
                        React.createElement(Spacing, { spacingLevel: { top: 3, bottom: 3 } },
                            React.createElement(Consumption, Object.assign({}, props.consumption)))))))),
            React.createElement("div", null,
                props.cardBody && (React.createElement(React.Fragment, null,
                    props.servicesIncluded && React.createElement(ServicesIncluded, Object.assign({}, props === null || props === void 0 ? void 0 : props.servicesIncluded)),
                    props.renewAndValidity && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, { noMargin: true, appearance: "secondary" }),
                        React.createElement(Spacing, { spacingLevel: { top: 3, bottom: 3 } },
                            React.createElement(RenewAndValidity, Object.assign({}, props.renewAndValidity, { autoRenew: props.renewAndValidity.autoRenew && Object.assign(Object.assign({}, props.renewAndValidity.autoRenew), { isActive: toggleState }), onChangeToggle: state => {
                                    var _a, _b;
                                    if ((_a = props.renewAndValidity) === null || _a === void 0 ? void 0 : _a.onChangeToggle) {
                                        (_b = props.renewAndValidity) === null || _b === void 0 ? void 0 : _b.onChangeToggle(state, props.id);
                                    }
                                    setToggleState(state);
                                } }))))),
                    props.consumption && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, { noMargin: true, appearance: "secondary" }),
                        React.createElement(Spacing, { spacingLevel: { top: 3, bottom: 3 } },
                            React.createElement(Consumption, Object.assign({}, props.consumption))))))),
                React.createElement(Spacing, { spacingLevel: { top: 4 } },
                    props.button && (React.createElement(Button, Object.assign({ appearance: (props.button.renderAppearance && props.button.renderAppearance(props.id)) ||
                            'alt1', text: props.button.renderText(props.id), onClick: () => props.button.action(props.id, toggleState), width: "full" }, addTestId((_e = props.testIds) === null || _e === void 0 ? void 0 : _e.button)))),
                    ((_f = props.link) === null || _f === void 0 ? void 0 : _f.text) && (React.createElement(LinkContainer, null,
                        React.createElement(Link, Object.assign({ text: props.link.text, onClick: () => props.link.action(props.id) }, addTestId((_g = props.testIds) === null || _g === void 0 ? void 0 : _g.link))))))))));
};

const AddonsListing = props => {
    var _a;
    return (React.createElement(CardGrid, { cardsOnLoad: props.cardsOnLoad, gridLayoutSize: props.gridLayoutSize, showMoreCards: props.showMoreCards, items: (_a = props.addons) === null || _a === void 0 ? void 0 : _a.map(addon => {
            var _a, _b;
            return (React.createElement(AddonCard, Object.assign({ key: addon.id }, addon, ((props === null || props === void 0 ? void 0 : props.button)
                ? {
                    button: {
                        renderText: props.button.renderText,
                        action: props.button.action,
                        renderAppearance: props.button.renderAppearance,
                    },
                }
                : {}), (((_a = props.link) === null || _a === void 0 ? void 0 : _a.text)
                ? {
                    link: {
                        text: props.link.text,
                        action: props.link.action,
                    },
                }
                : {}), (addon.renewAndValidity
                ? {
                    renewAndValidity: Object.assign(Object.assign({}, addon.renewAndValidity), { onChangeToggle: props.onChangeToggle
                            ? props.onChangeToggle
                            : (_b = addon.renewAndValidity) === null || _b === void 0 ? void 0 : _b.onChangeToggle }),
                }
                : {}))));
        }) }));
};

const CardBodyContainer = styled.div `
  padding: ${props => props.padding}px 0px;
  margin: ${props => props.margin}px 0px;
`;
const ItemContainer = styled.div `
  display: flex;
  margin-bottom: ${props => (props.isLastItem ? 0 : props.distanceBetweenItems)}px;
`;
const ParagraphDividerWrapper = styled.div `
  width: 100%;
`;
const AddonDetails = ({ addonDetailsItems, translatedHeader, selectAddonButton, }) => {
    var _a;
    const { translatedText, isSelected, handleSelectAddon } = selectAddonButton !== null && selectAddonButton !== void 0 ? selectAddonButton : {};
    return (React.createElement(React.Fragment, null,
        React.createElement(GridRow, { justify: "center", align: "center", marginTop: 4, marginBottom: 6, noGutters: true },
            React.createElement(GridColumn, null,
                React.createElement(Heading, { size: 2, text: translatedHeader, weight: 3, justify: "center" }))),
        React.createElement(GridRow, { justify: "center", align: "center", marginBottom: 5, noGutters: true },
            React.createElement(GridColumn, null,
                React.createElement(CardBodyContainer, { id: `${addonDetailsItems.id || ''}-cardbody-container`, padding: addonDetailsItems.padding, margin: addonDetailsItems.margin, "data-testid": "featuresSection" }, (_a = addonDetailsItems.items) === null || _a === void 0 ? void 0 : _a.map((item, index, items) => {
                    return (React.createElement("div", { key: `${addonDetailsItems.id || ''}-item${index}` },
                        React.createElement(ItemContainer, { key: `${addonDetailsItems.id || ''}-item${index}`, id: `${addonDetailsItems.id || ''}-item-${index}-container`, distanceBetweenItems: addonDetailsItems.distanceBetweenItems, isLastItem: index === items.length - 1, "data-testid": `feature-${index}` },
                            item.icon && (React.createElement("div", { style: { marginRight: addonDetailsItems.distanceBetweenItemsAndIcons } },
                                React.createElement(CommonIcon, { iconTopMargin: addonDetailsItems.iconTopMargin, width: addonDetailsItems.iconWidth, height: addonDetailsItems.iconHeight, src: item.icon, iconSize: addonDetailsItems.iconSize }))),
                            React.createElement(ParagraphDividerWrapper, null,
                                React.createElement(Paragraph, { size: 2, weight: 2 }, item.text),
                                index !== items.length - 1 && (React.createElement(Spacing, { spacingLevel: { bottom: 3, top: 6 } },
                                    React.createElement(Divider, { noMargin: true, appearance: "primary" })))))));
                })))),
        selectAddonButton && (React.createElement(GridRow, { justify: "center", align: "center", noGutters: true },
            React.createElement(Spacing, { spacingLevel: { top: 4 } },
                React.createElement(Button, { appearance: isSelected ? 'secondary' : 'primary', onClick: handleSelectAddon, text: translatedText }))))));
};

const {
  hasOwnProperty: hasOwnProp
} = Object.prototype;
/**
* @typedef {null|boolean|number|string|PlainObject|GenericArray} JSONObject
*/

/**
 * Copies array and then pushes item into it.
 * @param {GenericArray} arr Array to copy and into which to push
 * @param {any} item Array item to add (to end)
 * @returns {GenericArray} Copy of the original array
 */

function push$3(arr, item) {
  arr = arr.slice();
  arr.push(item);
  return arr;
}
/**
 * Copies array and then unshifts item into it.
 * @param {any} item Array item to add (to beginning)
 * @param {GenericArray} arr Array to copy and into which to unshift
 * @returns {GenericArray} Copy of the original array
 */


function unshift(item, arr) {
  arr = arr.slice();
  arr.unshift(item);
  return arr;
}
/**
 * Caught when JSONPath is used without `new` but rethrown if with `new`
 * @extends Error
 */


class NewError extends Error {
  /**
   * @param {any} value The evaluated scalar value
   */
  constructor(value) {
    super('JSONPath should not be called with "new" (it prevents return ' + 'of (unwrapped) scalar values)');
    this.avoidNew = true;
    this.value = value;
    this.name = 'NewError';
  }

}
/**
* @typedef {PlainObject} ReturnObject
* @property {string} path
* @property {JSONObject} value
* @property {PlainObject|GenericArray} parent
* @property {string} parentProperty
*/

/**
* @callback JSONPathCallback
* @param {string|PlainObject} preferredOutput
* @param {"value"|"property"} type
* @param {ReturnObject} fullRetObj
* @returns {void}
*/

/**
* @callback OtherTypeCallback
* @param {JSONObject} val
* @param {string} path
* @param {PlainObject|GenericArray} parent
* @param {string} parentPropName
* @returns {boolean}
*/

/* eslint-disable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @typedef {PlainObject} JSONPathOptions
 * @property {JSON} json
 * @property {string|string[]} path
 * @property {"value"|"path"|"pointer"|"parent"|"parentProperty"|"all"} [resultType="value"]
 * @property {boolean} [flatten=false]
 * @property {boolean} [wrap=true]
 * @property {PlainObject} [sandbox={}]
 * @property {boolean} [preventEval=false]
 * @property {PlainObject|GenericArray|null} [parent=null]
 * @property {string|null} [parentProperty=null]
 * @property {JSONPathCallback} [callback]
 * @property {OtherTypeCallback} [otherTypeCallback] Defaults to
 *   function which throws on encountering `@other`
 * @property {boolean} [autostart=true]
 */

/* eslint-enable max-len -- Can make multiline type after https://github.com/syavorsky/comment-parser/issues/109 */

/**
 * @param {string|JSONPathOptions} opts If a string, will be treated as `expr`
 * @param {string} [expr] JSON path to evaluate
 * @param {JSON} [obj] JSON object to evaluate against
 * @param {JSONPathCallback} [callback] Passed 3 arguments: 1) desired payload
 *     per `resultType`, 2) `"value"|"property"`, 3) Full returned object with
 *     all payloads
 * @param {OtherTypeCallback} [otherTypeCallback] If `@other()` is at the end
 *   of one's query, this will be invoked with the value of the item, its
 *   path, its parent, and its parent's property name, and it should return
 *   a boolean indicating whether the supplied value belongs to the "other"
 *   type or not (or it may handle transformations and return `false`).
 * @returns {JSONPath}
 * @class
 */


function JSONPath(opts, expr, obj, callback, otherTypeCallback) {
  // eslint-disable-next-line no-restricted-syntax
  if (!(this instanceof JSONPath)) {
    try {
      return new JSONPath(opts, expr, obj, callback, otherTypeCallback);
    } catch (e) {
      if (!e.avoidNew) {
        throw e;
      }

      return e.value;
    }
  }

  if (typeof opts === 'string') {
    otherTypeCallback = callback;
    callback = obj;
    obj = expr;
    expr = opts;
    opts = null;
  }

  const optObj = opts && typeof opts === 'object';
  opts = opts || {};
  this.json = opts.json || obj;
  this.path = opts.path || expr;
  this.resultType = opts.resultType || 'value';
  this.flatten = opts.flatten || false;
  this.wrap = hasOwnProp.call(opts, 'wrap') ? opts.wrap : true;
  this.sandbox = opts.sandbox || {};
  this.preventEval = opts.preventEval || false;
  this.parent = opts.parent || null;
  this.parentProperty = opts.parentProperty || null;
  this.callback = opts.callback || callback || null;

  this.otherTypeCallback = opts.otherTypeCallback || otherTypeCallback || function () {
    throw new TypeError('You must supply an otherTypeCallback callback option ' + 'with the @other() operator.');
  };

  if (opts.autostart !== false) {
    const args = {
      path: optObj ? opts.path : expr
    };

    if (!optObj) {
      args.json = obj;
    } else if ('json' in opts) {
      args.json = opts.json;
    }

    const ret = this.evaluate(args);

    if (!ret || typeof ret !== 'object') {
      throw new NewError(ret);
    }

    return ret;
  }
} // PUBLIC METHODS


JSONPath.prototype.evaluate = function (expr, json, callback, otherTypeCallback) {
  let currParent = this.parent,
      currParentProperty = this.parentProperty;
  let {
    flatten,
    wrap
  } = this;
  this.currResultType = this.resultType;
  this.currPreventEval = this.preventEval;
  this.currSandbox = this.sandbox;
  callback = callback || this.callback;
  this.currOtherTypeCallback = otherTypeCallback || this.otherTypeCallback;
  json = json || this.json;
  expr = expr || this.path;

  if (expr && typeof expr === 'object' && !Array.isArray(expr)) {
    if (!expr.path && expr.path !== '') {
      throw new TypeError('You must supply a "path" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    if (!hasOwnProp.call(expr, 'json')) {
      throw new TypeError('You must supply a "json" property when providing an object ' + 'argument to JSONPath.evaluate().');
    }

    ({
      json
    } = expr);
    flatten = hasOwnProp.call(expr, 'flatten') ? expr.flatten : flatten;
    this.currResultType = hasOwnProp.call(expr, 'resultType') ? expr.resultType : this.currResultType;
    this.currSandbox = hasOwnProp.call(expr, 'sandbox') ? expr.sandbox : this.currSandbox;
    wrap = hasOwnProp.call(expr, 'wrap') ? expr.wrap : wrap;
    this.currPreventEval = hasOwnProp.call(expr, 'preventEval') ? expr.preventEval : this.currPreventEval;
    callback = hasOwnProp.call(expr, 'callback') ? expr.callback : callback;
    this.currOtherTypeCallback = hasOwnProp.call(expr, 'otherTypeCallback') ? expr.otherTypeCallback : this.currOtherTypeCallback;
    currParent = hasOwnProp.call(expr, 'parent') ? expr.parent : currParent;
    currParentProperty = hasOwnProp.call(expr, 'parentProperty') ? expr.parentProperty : currParentProperty;
    expr = expr.path;
  }

  currParent = currParent || null;
  currParentProperty = currParentProperty || null;

  if (Array.isArray(expr)) {
    expr = JSONPath.toPathString(expr);
  }

  if (!expr && expr !== '' || !json) {
    return undefined;
  }

  const exprList = JSONPath.toPathArray(expr);

  if (exprList[0] === '$' && exprList.length > 1) {
    exprList.shift();
  }

  this._hasParentSelector = null;

  const result = this._trace(exprList, json, ['$'], currParent, currParentProperty, callback).filter(function (ea) {
    return ea && !ea.isParentSelector;
  });

  if (!result.length) {
    return wrap ? [] : undefined;
  }

  if (!wrap && result.length === 1 && !result[0].hasArrExpr) {
    return this._getPreferredOutput(result[0]);
  }

  return result.reduce((rslt, ea) => {
    const valOrPath = this._getPreferredOutput(ea);

    if (flatten && Array.isArray(valOrPath)) {
      rslt = rslt.concat(valOrPath);
    } else {
      rslt.push(valOrPath);
    }

    return rslt;
  }, []);
}; // PRIVATE METHODS


JSONPath.prototype._getPreferredOutput = function (ea) {
  const resultType = this.currResultType;

  switch (resultType) {
    case 'all':
      {
        const path = Array.isArray(ea.path) ? ea.path : JSONPath.toPathArray(ea.path);
        ea.pointer = JSONPath.toPointer(path);
        ea.path = typeof ea.path === 'string' ? ea.path : JSONPath.toPathString(ea.path);
        return ea;
      }

    case 'value':
    case 'parent':
    case 'parentProperty':
      return ea[resultType];

    case 'path':
      return JSONPath.toPathString(ea[resultType]);

    case 'pointer':
      return JSONPath.toPointer(ea.path);

    default:
      throw new TypeError('Unknown result type');
  }
};

JSONPath.prototype._handleCallback = function (fullRetObj, callback, type) {
  if (callback) {
    const preferredOutput = this._getPreferredOutput(fullRetObj);

    fullRetObj.path = typeof fullRetObj.path === 'string' ? fullRetObj.path : JSONPath.toPathString(fullRetObj.path); // eslint-disable-next-line node/callback-return

    callback(preferredOutput, type, fullRetObj);
  }
};
/**
 *
 * @param {string} expr
 * @param {JSONObject} val
 * @param {string} path
 * @param {PlainObject|GenericArray} parent
 * @param {string} parentPropName
 * @param {JSONPathCallback} callback
 * @param {boolean} hasArrExpr
 * @param {boolean} literalPriority
 * @returns {ReturnObject|ReturnObject[]}
 */


JSONPath.prototype._trace = function (expr, val, path, parent, parentPropName, callback, hasArrExpr, literalPriority) {
  // No expr to follow? return path and value as the result of
  //  this trace branch
  let retObj;

  if (!expr.length) {
    retObj = {
      path,
      value: val,
      parent,
      parentProperty: parentPropName,
      hasArrExpr
    };

    this._handleCallback(retObj, callback, 'value');

    return retObj;
  }

  const loc = expr[0],
        x = expr.slice(1); // We need to gather the return value of recursive trace calls in order to
  // do the parent sel computation.

  const ret = [];
  /**
   *
   * @param {ReturnObject|ReturnObject[]} elems
   * @returns {void}
   */

  function addRet(elems) {
    if (Array.isArray(elems)) {
      // This was causing excessive stack size in Node (with or
      //  without Babel) against our performance test:
      //  `ret.push(...elems);`
      elems.forEach(t => {
        ret.push(t);
      });
    } else {
      ret.push(elems);
    }
  }

  if ((typeof loc !== 'string' || literalPriority) && val && hasOwnProp.call(val, loc)) {
    // simple case--directly follow property
    addRet(this._trace(x, val[loc], push$3(path, loc), val, loc, callback, hasArrExpr)); // eslint-disable-next-line unicorn/prefer-switch -- Part of larger `if`
  } else if (loc === '*') {
    // all child properties
    this._walk(loc, x, val, path, parent, parentPropName, callback, (m, l, _x, v, p, par, pr, cb) => {
      addRet(this._trace(unshift(m, _x), v, p, par, pr, cb, true, true));
    });
  } else if (loc === '..') {
    // all descendent parent properties
    // Check remaining expression with val's immediate children
    addRet(this._trace(x, val, path, parent, parentPropName, callback, hasArrExpr));

    this._walk(loc, x, val, path, parent, parentPropName, callback, (m, l, _x, v, p, par, pr, cb) => {
      // We don't join m and x here because we only want parents,
      //   not scalar values
      if (typeof v[m] === 'object') {
        // Keep going with recursive descent on val's
        //   object children
        addRet(this._trace(unshift(l, _x), v[m], push$3(p, m), v, m, cb, true));
      }
    }); // The parent sel computation is handled in the frame above using the
    // ancestor object of val

  } else if (loc === '^') {
    // This is not a final endpoint, so we do not invoke the callback here
    this._hasParentSelector = true;
    return {
      path: path.slice(0, -1),
      expr: x,
      isParentSelector: true
    };
  } else if (loc === '~') {
    // property name
    retObj = {
      path: push$3(path, loc),
      value: parentPropName,
      parent,
      parentProperty: null
    };

    this._handleCallback(retObj, callback, 'property');

    return retObj;
  } else if (loc === '$') {
    // root only
    addRet(this._trace(x, val, path, null, null, callback, hasArrExpr));
  } else if (/^(-?\d*):(-?\d*):?(\d*)$/u.test(loc)) {
    // [start:end:step]  Python slice syntax
    addRet(this._slice(loc, x, val, path, parent, parentPropName, callback));
  } else if (loc.indexOf('?(') === 0) {
    // [?(expr)] (filtering)
    if (this.currPreventEval) {
      throw new Error('Eval [?(expr)] prevented in JSONPath expression.');
    }

    this._walk(loc, x, val, path, parent, parentPropName, callback, (m, l, _x, v, p, par, pr, cb) => {
      if (this._eval(l.replace(/^\?\((.*?)\)$/u, '$1'), v[m], m, p, par, pr)) {
        addRet(this._trace(unshift(m, _x), v, p, par, pr, cb, true));
      }
    });
  } else if (loc[0] === '(') {
    // [(expr)] (dynamic property/index)
    if (this.currPreventEval) {
      throw new Error('Eval [(expr)] prevented in JSONPath expression.');
    } // As this will resolve to a property name (but we don't know it
    //  yet), property and parent information is relative to the
    //  parent of the property to which this expression will resolve


    addRet(this._trace(unshift(this._eval(loc, val, path[path.length - 1], path.slice(0, -1), parent, parentPropName), x), val, path, parent, parentPropName, callback, hasArrExpr));
  } else if (loc[0] === '@') {
    // value type: @boolean(), etc.
    let addType = false;
    const valueType = loc.slice(1, -2);

    switch (valueType) {
      case 'scalar':
        if (!val || !['object', 'function'].includes(typeof val)) {
          addType = true;
        }

        break;

      case 'boolean':
      case 'string':
      case 'undefined':
      case 'function':
        // eslint-disable-next-line valid-typeof
        if (typeof val === valueType) {
          addType = true;
        }

        break;

      case 'integer':
        if (Number.isFinite(val) && !(val % 1)) {
          addType = true;
        }

        break;

      case 'number':
        if (Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'nonFinite':
        if (typeof val === 'number' && !Number.isFinite(val)) {
          addType = true;
        }

        break;

      case 'object':
        // eslint-disable-next-line valid-typeof
        if (val && typeof val === valueType) {
          addType = true;
        }

        break;

      case 'array':
        if (Array.isArray(val)) {
          addType = true;
        }

        break;

      case 'other':
        addType = this.currOtherTypeCallback(val, path, parent, parentPropName);
        break;

      case 'null':
        if (val === null) {
          addType = true;
        }

        break;

      /* c8 ignore next 2 */

      default:
        throw new TypeError('Unknown value type ' + valueType);
    }

    if (addType) {
      retObj = {
        path,
        value: val,
        parent,
        parentProperty: parentPropName
      };

      this._handleCallback(retObj, callback, 'value');

      return retObj;
    } // `-escaped property

  } else if (loc[0] === '`' && val && hasOwnProp.call(val, loc.slice(1))) {
    const locProp = loc.slice(1);
    addRet(this._trace(x, val[locProp], push$3(path, locProp), val, locProp, callback, hasArrExpr, true));
  } else if (loc.includes(',')) {
    // [name1,name2,...]
    const parts = loc.split(',');

    for (const part of parts) {
      addRet(this._trace(unshift(part, x), val, path, parent, parentPropName, callback, true));
    } // simple case--directly follow property

  } else if (!literalPriority && val && hasOwnProp.call(val, loc)) {
    addRet(this._trace(x, val[loc], push$3(path, loc), val, loc, callback, hasArrExpr, true));
  } // We check the resulting values for parent selections. For parent
  // selections we discard the value object and continue the trace with the
  // current val object


  if (this._hasParentSelector) {
    for (let t = 0; t < ret.length; t++) {
      const rett = ret[t];

      if (rett && rett.isParentSelector) {
        const tmp = this._trace(rett.expr, val, rett.path, parent, parentPropName, callback, hasArrExpr);

        if (Array.isArray(tmp)) {
          ret[t] = tmp[0];
          const tl = tmp.length;

          for (let tt = 1; tt < tl; tt++) {
            t++;
            ret.splice(t, 0, tmp[tt]);
          }
        } else {
          ret[t] = tmp;
        }
      }
    }
  }

  return ret;
};

JSONPath.prototype._walk = function (loc, expr, val, path, parent, parentPropName, callback, f) {
  if (Array.isArray(val)) {
    const n = val.length;

    for (let i = 0; i < n; i++) {
      f(i, loc, expr, val, path, parent, parentPropName, callback);
    }
  } else if (val && typeof val === 'object') {
    Object.keys(val).forEach(m => {
      f(m, loc, expr, val, path, parent, parentPropName, callback);
    });
  }
};

JSONPath.prototype._slice = function (loc, expr, val, path, parent, parentPropName, callback) {
  if (!Array.isArray(val)) {
    return undefined;
  }

  const len = val.length,
        parts = loc.split(':'),
        step = parts[2] && Number.parseInt(parts[2]) || 1;
  let start = parts[0] && Number.parseInt(parts[0]) || 0,
      end = parts[1] && Number.parseInt(parts[1]) || len;
  start = start < 0 ? Math.max(0, start + len) : Math.min(len, start);
  end = end < 0 ? Math.max(0, end + len) : Math.min(len, end);
  const ret = [];

  for (let i = start; i < end; i += step) {
    const tmp = this._trace(unshift(i, expr), val, path, parent, parentPropName, callback, true); // Should only be possible to be an array here since first part of
    //   ``unshift(i, expr)` passed in above would not be empty, nor `~`,
    //     nor begin with `@` (as could return objects)
    // This was causing excessive stack size in Node (with or
    //  without Babel) against our performance test: `ret.push(...tmp);`


    tmp.forEach(t => {
      ret.push(t);
    });
  }

  return ret;
};

JSONPath.prototype._eval = function (code, _v, _vname, path, parent, parentPropName) {
  if (code.includes('@parentProperty')) {
    this.currSandbox._$_parentProperty = parentPropName;
    code = code.replace(/@parentProperty/gu, '_$_parentProperty');
  }

  if (code.includes('@parent')) {
    this.currSandbox._$_parent = parent;
    code = code.replace(/@parent/gu, '_$_parent');
  }

  if (code.includes('@property')) {
    this.currSandbox._$_property = _vname;
    code = code.replace(/@property/gu, '_$_property');
  }

  if (code.includes('@path')) {
    this.currSandbox._$_path = JSONPath.toPathString(path.concat([_vname]));
    code = code.replace(/@path/gu, '_$_path');
  }

  if (code.includes('@root')) {
    this.currSandbox._$_root = this.json;
    code = code.replace(/@root/gu, '_$_root');
  }

  if (/@([.\s)[])/u.test(code)) {
    this.currSandbox._$_v = _v;
    code = code.replace(/@([.\s)[])/gu, '_$_v$1');
  }

  try {
    return this.vm.runInNewContext(code, this.currSandbox);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    throw new Error('jsonPath: ' + e.message + ': ' + code);
  }
}; // PUBLIC CLASS PROPERTIES AND METHODS
// Could store the cache object itself


JSONPath.cache = {};
/**
 * @param {string[]} pathArr Array to convert
 * @returns {string} The path string
 */

JSONPath.toPathString = function (pathArr) {
  const x = pathArr,
        n = x.length;
  let p = '$';

  for (let i = 1; i < n; i++) {
    if (!/^(~|\^|@.*?\(\))$/u.test(x[i])) {
      p += /^[0-9*]+$/u.test(x[i]) ? '[' + x[i] + ']' : "['" + x[i] + "']";
    }
  }

  return p;
};
/**
 * @param {string} pointer JSON Path
 * @returns {string} JSON Pointer
 */


JSONPath.toPointer = function (pointer) {
  const x = pointer,
        n = x.length;
  let p = '';

  for (let i = 1; i < n; i++) {
    if (!/^(~|\^|@.*?\(\))$/u.test(x[i])) {
      p += '/' + x[i].toString().replace(/~/gu, '~0').replace(/\//gu, '~1');
    }
  }

  return p;
};
/**
 * @param {string} expr Expression to convert
 * @returns {string[]}
 */


JSONPath.toPathArray = function (expr) {
  const {
    cache
  } = JSONPath;

  if (cache[expr]) {
    return cache[expr].concat();
  }

  const subx = [];
  const normalized = expr // Properties
  .replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/gu, ';$&;') // Parenthetical evaluations (filtering and otherwise), directly
  //   within brackets or single quotes
  .replace(/[['](\??\(.*?\))[\]']/gu, function ($0, $1) {
    return '[#' + (subx.push($1) - 1) + ']';
  }) // Escape periods and tildes within properties
  .replace(/\[['"]([^'\]]*)['"]\]/gu, function ($0, prop) {
    return "['" + prop.replace(/\./gu, '%@%').replace(/~/gu, '%%@@%%') + "']";
  }) // Properties operator
  .replace(/~/gu, ';~;') // Split by property boundaries
  .replace(/['"]?\.['"]?(?![^[]*\])|\[['"]?/gu, ';') // Reinsert periods within properties
  .replace(/%@%/gu, '.') // Reinsert tildes within properties
  .replace(/%%@@%%/gu, '~') // Parent
  .replace(/(?:;)?(\^+)(?:;)?/gu, function ($0, ups) {
    return ';' + ups.split('').join(';') + ';';
  }) // Descendents
  .replace(/;;;|;;/gu, ';..;') // Remove trailing
  .replace(/;$|'?\]|'$/gu, '');
  const exprList = normalized.split(';').map(function (exp) {
    const match = exp.match(/#(\d+)/u);
    return !match || !match[1] ? exp : subx[match[1]];
  });
  cache[expr] = exprList;
  return cache[expr].concat();
};

JSONPath.prototype.vm = vm;

/**
 * It takes a JSONPath string and a JSON object, and returns the value of the JSONPath string in the
 * JSON object
 * @param {string} path - The JSONPath expression to use.
 * @param {object} json - The JSON object to search
 * @returns The value of the path in the json object.
 */
const getValueFromJson = (path, json) => {
    if (!path || !json)
        return;
    try {
        const result = JSONPath({ path, json });
        return result.length > 0 ? result : null;
    }
    catch (e) {
        throw new Error(e.message);
    }
};

/**
 * Formats a given number (or String) of MB (numbers only) and returns a user-friendly  String
 * for presentation. Τhe MB are divided to 1024
 * @param {string|number} amount The amount in MB you want to format.
 * @return {string} The formatted amount in ( MB | GB )
 * @example
 * formatMB("1200")
 * "1.2GB"
 * @formatMB("1000")
 * "1GB"
 */
const formatMB = (megaBytes, decimals = 1) => {
    if (isNaN(+megaBytes) || +megaBytes < 0) {
        return '';
    }
    const amountNumber = normalizeInput(megaBytes);
    if (amountNumber < 1024) {
        return `${amountNumber}MB`;
    }
    const dividedMegabytes = (amountNumber / 1024).toFixed(decimals);
    const formattedAmount = parseFloat(dividedMegabytes);
    // 56.2310 -> "56.23";
    return `${formattedAmount}GB`;
};

/**
* this function for mapping upselling products
* @param {SchemaType} schema - The JSONPath expression to use per each field must match SchemaType interface.
* @param {ProductTMF} TMF - The object to search
* static keys shouldn't be passed
* arrayofStringsKeys & arrayofNumbersKeys are special arrays for handling numbers & array of strings
*/
const mapProductTMF = (TMF, schema) => {
    Object.keys(schema).forEach((key) => {
        var _a;
        if (typeof (schema[key]) == "string") {
            const arrayofStringsKeys = ["topFeaturesList", "modalDetailsList"];
            const arrayofNumbersKeys = ["value"];
            schema[key] = arrayofStringsKeys.includes(key) ?
                (getValueFromJson((schema[key]), TMF)) :
                schema[key] = arrayofNumbersKeys.includes(key) ?
                    +`${(getValueFromJson((schema[key]), TMF))}` :
                    `${(getValueFromJson((schema[key]), TMF))}`;
        }
        else {
            //to check array flow
            if (((_a = schema[key]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                schema[key].map((data) => {
                    mapProductTMF(TMF, data);
                });
            }
            else {
                //to check object flow
                mapProductTMF(TMF, (schema[key]));
            }
        }
    });
    return schema;
};

const setInsuranceType = (type) => {
    let insuranceType;
    switch (type) {
        case 'SOT_INSURANCE_GOLD':
            insuranceType = 'goldInsurance';
            break;
        case 'SOT_INSURANCE_SILVER':
            insuranceType = 'silverInsurance';
            break;
    }
    return insuranceType;
};

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/** Used to determine if values are of the language type Object */
var objectTypes$3 = {
  'boolean': false,
  'function': true,
  'object': true,
  'number': false,
  'string': false,
  'undefined': false
};

var lodash__objecttypes = objectTypes$3;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var objectTypes$2 = lodash__objecttypes;

/**
 * Checks if `value` is the language type of Object.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject$4(value) {
  // check if the value is the ECMAScript language type of Object
  // http://es5.github.io/#x8
  // and avoid a V8 bug
  // http://code.google.com/p/v8/issues/detail?id=2291
  return !!(value && objectTypes$2[typeof value]);
}

var lodash_isobject = isObject$4;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/** Used for native method references */
var objectProto$1 = Object.prototype;

/** Used to resolve the internal [[Class]] of values */
var toString = objectProto$1.toString;

/** Used to detect if a method is native */
var reNative$4 = RegExp('^' +
  String(toString)
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .replace(/toString| for [^\]]+/g, '.*?') + '$'
);

var lodash__renative = reNative$4;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var objectTypes$1 = lodash__objecttypes;

/** Used for native method references */
var objectProto = Object.prototype;

/** Native method shortcuts */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A fallback implementation of `Object.keys` which produces an array of the
 * given object's own enumerable property names.
 *
 * @private
 * @type Function
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns an array of property names.
 */
var shimKeys$1 = function(object) {
  var index, iterable = object, result = [];
  if (!iterable) return result;
  if (!(objectTypes$1[typeof object])) return result;
    for (index in iterable) {
      if (hasOwnProperty.call(iterable, index)) {
        result.push(index);
      }
    }
  return result
};

var lodash__shimkeys = shimKeys$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var isObject$3 = lodash_isobject,
    reNative$3 = lodash__renative,
    shimKeys = lodash__shimkeys;

/* Native method shortcuts for methods with the same name as other `lodash` methods */
var nativeKeys = reNative$3.test(nativeKeys = Object.keys) && nativeKeys;

/**
 * Creates an array composed of the own enumerable property names of an object.
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns an array of property names.
 * @example
 *
 * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
 * // => ['one', 'two', 'three'] (property order is not guaranteed across environments)
 */
var keys$2 = !nativeKeys ? shimKeys : function(object) {
  if (!isObject$3(object)) {
    return [];
  }
  return nativeKeys(object);
};

var lodash_keys = keys$2;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * A no-operation function.
 *
 * @static
 * @memberOf _
 * @category Utilities
 * @example
 *
 * var object = { 'name': 'fred' };
 * _.noop(object) === undefined;
 * // => true
 */
function noop$1() {
  // no operation performed
}

var lodash_noop = noop$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var isObject$2 = lodash_isobject,
    reNative$2 = lodash__renative;

/* Native method shortcuts for methods with the same name as other `lodash` methods */
var nativeCreate = reNative$2.test(nativeCreate = Object.create) && nativeCreate;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate$2(prototype, properties) {
  return isObject$2(prototype) ? nativeCreate(prototype) : {};
}
// fallback for browsers without `Object.create`
if (!nativeCreate) {
  baseCreate$2 = (function() {
    function Object() {}
    return function(prototype) {
      if (isObject$2(prototype)) {
        Object.prototype = prototype;
        var result = new Object;
        Object.prototype = null;
      }
      return result || commonjsGlobal.Object();
    };
  }());
}

var lodash__basecreate = baseCreate$2;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var noop = lodash_noop,
    reNative$1 = lodash__renative;

/** Used as the property descriptor for `__bindData__` */
var descriptor = {
  'configurable': false,
  'enumerable': false,
  'value': null,
  'writable': false
};

/** Used to set meta data on functions */
var defineProperty = (function() {
  // IE 8 only accepts DOM elements
  try {
    var o = {},
        func = reNative$1.test(func = Object.defineProperty) && func,
        result = func(o, o, o) && func;
  } catch(e) { }
  return result;
}());

/**
 * Sets `this` binding data on a given function.
 *
 * @private
 * @param {Function} func The function to set data on.
 * @param {Array} value The data array to set.
 */
var setBindData$3 = !defineProperty ? noop : function(func, value) {
  descriptor.value = value;
  defineProperty(func, '__bindData__', descriptor);
};

var lodash__setbinddata = setBindData$3;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var baseCreate$1 = lodash__basecreate,
    isObject$1 = lodash_isobject,
    setBindData$2 = lodash__setbinddata;

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef$2 = [];

/** Native method shortcuts */
var push$2 = arrayRef$2.push;

/**
 * The base implementation of `_.bind` that creates the bound function and
 * sets its meta data.
 *
 * @private
 * @param {Array} bindData The bind data array.
 * @returns {Function} Returns the new bound function.
 */
function baseBind$1(bindData) {
  var func = bindData[0],
      partialArgs = bindData[2],
      thisArg = bindData[4];

  function bound() {
    // `Function#bind` spec
    // http://es5.github.io/#x15.3.4.5
    if (partialArgs) {
      var args = partialArgs.slice();
      push$2.apply(args, arguments);
    }
    // mimic the constructor's `return` behavior
    // http://es5.github.io/#x13.2.2
    if (this instanceof bound) {
      // ensure `new bound` is an instance of `func`
      var thisBinding = baseCreate$1(func.prototype),
          result = func.apply(thisBinding, args || arguments);
      return isObject$1(result) ? result : thisBinding;
    }
    return func.apply(thisArg, args || arguments);
  }
  setBindData$2(bound, bindData);
  return bound;
}

var lodash__basebind = baseBind$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * Slices the `collection` from the `start` index up to, but not including,
 * the `end` index.
 *
 * Note: This function is used instead of `Array#slice` to support node lists
 * in IE < 9 and to ensure dense arrays are returned.
 *
 * @private
 * @param {Array|Object|string} collection The collection to slice.
 * @param {number} start The start index.
 * @param {number} end The end index.
 * @returns {Array} Returns the new array.
 */
function slice$2(array, start, end) {
  start || (start = 0);
  if (typeof end == 'undefined') {
    end = array ? array.length : 0;
  }
  var index = -1,
      length = end - start || 0,
      result = Array(length < 0 ? 0 : length);

  while (++index < length) {
    result[index] = array[start + index];
  }
  return result;
}

var lodash__slice = slice$2;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var baseCreate = lodash__basecreate,
    isObject = lodash_isobject,
    setBindData$1 = lodash__setbinddata,
    slice$1 = lodash__slice;

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef$1 = [];

/** Native method shortcuts */
var push$1 = arrayRef$1.push;

/**
 * The base implementation of `createWrapper` that creates the wrapper and
 * sets its meta data.
 *
 * @private
 * @param {Array} bindData The bind data array.
 * @returns {Function} Returns the new function.
 */
function baseCreateWrapper$1(bindData) {
  var func = bindData[0],
      bitmask = bindData[1],
      partialArgs = bindData[2],
      partialRightArgs = bindData[3],
      thisArg = bindData[4],
      arity = bindData[5];

  var isBind = bitmask & 1,
      isBindKey = bitmask & 2,
      isCurry = bitmask & 4,
      isCurryBound = bitmask & 8,
      key = func;

  function bound() {
    var thisBinding = isBind ? thisArg : this;
    if (partialArgs) {
      var args = partialArgs.slice();
      push$1.apply(args, arguments);
    }
    if (partialRightArgs || isCurry) {
      args || (args = slice$1(arguments));
      if (partialRightArgs) {
        push$1.apply(args, partialRightArgs);
      }
      if (isCurry && args.length < arity) {
        bitmask |= 16 & ~32;
        return baseCreateWrapper$1([func, (isCurryBound ? bitmask : bitmask & ~3), args, null, thisArg, arity]);
      }
    }
    args || (args = arguments);
    if (isBindKey) {
      func = thisBinding[key];
    }
    if (this instanceof bound) {
      thisBinding = baseCreate(func.prototype);
      var result = func.apply(thisBinding, args);
      return isObject(result) ? result : thisBinding;
    }
    return func.apply(thisBinding, args);
  }
  setBindData$1(bound, bindData);
  return bound;
}

var lodash__basecreatewrapper = baseCreateWrapper$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * Checks if `value` is a function.
 *
 * @static
 * @memberOf _
 * @category Objects
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if the `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 */
function isFunction$1(value) {
  return typeof value == 'function';
}

var lodash_isfunction = isFunction$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var baseBind = lodash__basebind,
    baseCreateWrapper = lodash__basecreatewrapper,
    isFunction = lodash_isfunction;

/**
 * Used for `Array` method references.
 *
 * Normally `Array.prototype` would suffice, however, using an array literal
 * avoids issues in Narwhal.
 */
var arrayRef = [];

/** Native method shortcuts */
var push = arrayRef.push;

/**
 * Creates a function that, when called, either curries or invokes `func`
 * with an optional `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to reference.
 * @param {number} bitmask The bitmask of method flags to compose.
 *  The bitmask may be composed of the following flags:
 *  1 - `_.bind`
 *  2 - `_.bindKey`
 *  4 - `_.curry`
 *  8 - `_.curry` (bound)
 *  16 - `_.partial`
 *  32 - `_.partialRight`
 * @param {Array} [partialArgs] An array of arguments to prepend to those
 *  provided to the new function.
 * @param {Array} [partialRightArgs] An array of arguments to append to those
 *  provided to the new function.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new function.
 */
function createWrapper$1(func, bitmask, partialArgs, partialRightArgs, thisArg, arity) {
  var isBind = bitmask & 1,
      isBindKey = bitmask & 2,
      isCurry = bitmask & 4,
      isPartial = bitmask & 16,
      isPartialRight = bitmask & 32;

  if (!isBindKey && !isFunction(func)) {
    throw new TypeError;
  }
  if (isPartial && !partialArgs.length) {
    bitmask &= ~16;
    isPartial = partialArgs = false;
  }
  if (isPartialRight && !partialRightArgs.length) {
    bitmask &= ~32;
    isPartialRight = partialRightArgs = false;
  }
  var bindData = func && func.__bindData__;
  if (bindData && bindData !== true) {
    bindData = bindData.slice();

    // set `thisBinding` is not previously bound
    if (isBind && !(bindData[1] & 1)) {
      bindData[4] = thisArg;
    }
    // set if previously bound but not currently (subsequent curried functions)
    if (!isBind && bindData[1] & 1) {
      bitmask |= 8;
    }
    // set curried arity if not yet set
    if (isCurry && !(bindData[1] & 4)) {
      bindData[5] = arity;
    }
    // append partial left arguments
    if (isPartial) {
      push.apply(bindData[2] || (bindData[2] = []), partialArgs);
    }
    // append partial right arguments
    if (isPartialRight) {
      push.apply(bindData[3] || (bindData[3] = []), partialRightArgs);
    }
    // merge flags
    bindData[1] |= bitmask;
    return createWrapper$1.apply(null, bindData);
  }
  // fast path for `_.bind`
  var creater = (bitmask == 1 || bitmask === 17) ? baseBind : baseCreateWrapper;
  return creater([func, bitmask, partialArgs, partialRightArgs, thisArg, arity]);
}

var lodash__createwrapper = createWrapper$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var createWrapper = lodash__createwrapper,
    slice = lodash__slice;

/**
 * Creates a function that, when called, invokes `func` with the `this`
 * binding of `thisArg` and prepends any additional `bind` arguments to those
 * provided to the bound function.
 *
 * @static
 * @memberOf _
 * @category Functions
 * @param {Function} func The function to bind.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {...*} [arg] Arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var func = function(greeting) {
 *   return greeting + ' ' + this.name;
 * };
 *
 * func = _.bind(func, { 'name': 'fred' }, 'hi');
 * func();
 * // => 'hi fred'
 */
function bind$1(func, thisArg) {
  return arguments.length > 2
    ? createWrapper(func, 17, slice(arguments, 2), null, thisArg)
    : createWrapper(func, 1, null, null, thisArg);
}

var lodash_bind = bind$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utilities
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'name': 'fred' };
 * _.identity(object) === object;
 * // => true
 */
function identity$1(value) {
  return value;
}

var lodash_identity = identity$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var reNative = lodash__renative;

/** Used to detect functions containing a `this` reference */
var reThis$1 = /\bthis\b/;

/**
 * An object used to flag environments features.
 *
 * @static
 * @memberOf _
 * @type Object
 */
var support$1 = {};

/**
 * Detect if functions can be decompiled by `Function#toString`
 * (all but PS3 and older Opera mobile browsers & avoided in Windows 8 apps).
 *
 * @memberOf _.support
 * @type boolean
 */
support$1.funcDecomp = !reNative.test(commonjsGlobal.WinRTError) && reThis$1.test(function() { return this; });

/**
 * Detect if `Function#name` is supported (all but IE).
 *
 * @memberOf _.support
 * @type boolean
 */
support$1.funcNames = typeof Function.name == 'string';

var lodash_support = support$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var bind = lodash_bind,
    identity = lodash_identity,
    setBindData = lodash__setbinddata,
    support = lodash_support;

/** Used to detected named functions */
var reFuncName = /^\s*function[ \n\r\t]+\w/;

/** Used to detect functions containing a `this` reference */
var reThis = /\bthis\b/;

/** Native method shortcuts */
var fnToString = Function.prototype.toString;

/**
 * The base implementation of `_.createCallback` without support for creating
 * "_.pluck" or "_.where" style callbacks.
 *
 * @private
 * @param {*} [func=identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of the created callback.
 * @param {number} [argCount] The number of arguments the callback accepts.
 * @returns {Function} Returns a callback function.
 */
function baseCreateCallback$2(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  // exit early for no `thisArg` or already bound by `Function#bind`
  if (typeof thisArg == 'undefined' || !('prototype' in func)) {
    return func;
  }
  var bindData = func.__bindData__;
  if (typeof bindData == 'undefined') {
    if (support.funcNames) {
      bindData = !func.name;
    }
    bindData = bindData || !support.funcDecomp;
    if (!bindData) {
      var source = fnToString.call(func);
      if (!support.funcNames) {
        bindData = !reFuncName.test(source);
      }
      if (!bindData) {
        // checks if `func` references the `this` keyword and stores the result
        bindData = reThis.test(source);
        setBindData(func, bindData);
      }
    }
  }
  // exit early if there are no `this` references or `func` is bound
  if (bindData === false || (bindData !== true && bindData[1] & 1)) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 2: return function(a, b) {
      return func.call(thisArg, a, b);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
  }
  return bind(func, thisArg);
}

var lodash__basecreatecallback = baseCreateCallback$2;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var baseCreateCallback$1 = lodash__basecreatecallback,
    keys$1 = lodash_keys,
    objectTypes = lodash__objecttypes;

/**
 * Iterates over own enumerable properties of an object, executing the callback
 * for each property. The callback is bound to `thisArg` and invoked with three
 * arguments; (value, key, object). Callbacks may exit iteration early by
 * explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Objects
 * @param {Object} object The object to iterate over.
 * @param {Function} [callback=identity] The function called per iteration.
 * @param {*} [thisArg] The `this` binding of `callback`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
 *   console.log(key);
 * });
 * // => logs '0', '1', and 'length' (property order is not guaranteed across environments)
 */
var forOwn$1 = function(collection, callback, thisArg) {
  var index, iterable = collection, result = iterable;
  if (!iterable) return result;
  if (!objectTypes[typeof iterable]) return result;
  callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback$1(callback, thisArg, 3);
    var ownIndex = -1,
        ownProps = objectTypes[typeof iterable] && keys$1(iterable),
        length = ownProps ? ownProps.length : 0;

    while (++ownIndex < length) {
      index = ownProps[ownIndex];
      if (callback(iterable[index], index, collection) === false) return result;
    }
  return result
};

var lodash_forown = forOwn$1;

/**
 * Lo-Dash 2.3.0 (Custom Build) <http://lodash.com/>
 * Build: `lodash modularize modern exports="npm" -o ./npm/`
 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.5.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <http://lodash.com/license>
 */

var baseCreateCallback = lodash__basecreatecallback,
    forOwn = lodash_forown;

/**
 * Iterates over elements of a collection, executing the callback for each
 * element. The callback is bound to `thisArg` and invoked with three arguments;
 * (value, index|key, collection). Callbacks may exit iteration early by
 * explicitly returning `false`.
 *
 * Note: As with other "Collections" methods, objects with a `length` property
 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
 * may be used for object iteration.
 *
 * @static
 * @memberOf _
 * @alias each
 * @category Collections
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [callback=identity] The function called per iteration.
 * @param {*} [thisArg] The `this` binding of `callback`.
 * @returns {Array|Object|string} Returns `collection`.
 * @example
 *
 * _([1, 2, 3]).forEach(function(num) { console.log(num); }).join(',');
 * // => logs each number and returns '1,2,3'
 *
 * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { console.log(num); });
 * // => logs each number and returns the object (property order is not guaranteed across environments)
 */
function forEach(collection, callback, thisArg) {
  var index = -1,
      length = collection ? collection.length : 0;

  callback = callback && typeof thisArg == 'undefined' ? callback : baseCreateCallback(callback, thisArg, 3);
  if (typeof length == 'number') {
    while (++index < length) {
      if (callback(collection[index], index, collection) === false) {
        break;
      }
    }
  } else {
    forOwn(collection, callback);
  }
  return collection;
}

var lodash_foreach = forEach;

var metric$b,
imperial$9;

metric$b = {
  mm: {
    name: {
      singular: 'Millimeter',
      plural: 'Millimeters'
    },
    to_anchor: 1/1000
  },
  cm: {
    name: {
      singular: 'Centimeter',
      plural: 'Centimeters'
    },
    to_anchor: 1/100
  },
  m: {
    name: {
      singular: 'Meter',
      plural: 'Meters'
    },
    to_anchor: 1
  },
  km: {
    name: {
      singular: 'Kilometer',
      plural: 'Kilometers'
    },
    to_anchor: 1000
  }
};

imperial$9 = {
  'in': {
    name: {
      singular: 'Inch',
      plural: 'Inches'
    },
    to_anchor: 1/12
  },
  yd: {
    name: {
      singular: 'Yard',
      plural: 'Yards'
    },
    to_anchor: 3
  },
  'ft-us': {
    name: {
      singular: 'US Survey Foot',
      plural: 'US Survey Feet'
    },
    to_anchor: 1.000002
  },
  ft: {
    name: {
      singular: 'Foot',
      plural: 'Feet'
    },
    to_anchor: 1
  },
  mi: {
    name: {
      singular: 'Mile',
      plural: 'Miles'
    },
    to_anchor: 5280
  }
};

var length = {
  metric: metric$b,
  imperial: imperial$9,
  _anchors: {
    metric: {
      unit: 'm',
      ratio: 3.28084
    },
    imperial: {
      unit: 'ft',
      ratio: 1/3.28084
    }
  }
};

var metric$a
  , imperial$8;

metric$a = {
  mm2: {
    name: {
      singular: 'Square Millimeter'
    , plural: 'Square Millimeters'
    }
  , to_anchor: 1/1000000
  }
, cm2: {
    name: {
      singular: 'Centimeter'
    , plural: 'Centimeters'
    }
  , to_anchor: 1/10000
  }
, m2: {
    name: {
      singular: 'Square Meter'
    , plural: 'Square Meters'
    }
  , to_anchor: 1
  }
, ha: {
    name: {
      singular: 'Hectare'
    , plural: 'Hectares'
    }
  , to_anchor: 10000
  }
, km2: {
    name: {
      singular: 'Square Kilometer'
    , plural: 'Square Kilometers'
    }
  , to_anchor: 1000000
  }
};

imperial$8 = {
  'in2': {
    name: {
      singular: 'Square Inch'
    , plural: 'Square Inches'
    }
  , to_anchor: 1/144
  }
, yd2: {
    name: {
      singular: 'Square Yard'
    , plural: 'Square Yards'  
    }
  , to_anchor: 9
  }
, ft2: {
    name: {
      singular: 'Square Foot'
    , plural: 'Square Feet'
    }
  , to_anchor: 1
  }
, ac: {
    name: {
      singular: 'Acre'
    , plural: 'Acres'
    }
  , to_anchor: 43560
  }
, mi2: {
    name: {
      singular: 'Square Mile'
    , plural: 'Square Miles'
    }
  , to_anchor: 27878400
  }
};

var area = {
  metric: metric$a
, imperial: imperial$8
, _anchors: {
    metric: {
      unit: 'm2'
    , ratio: 10.7639
    }
  , imperial: {
      unit: 'ft2'
    , ratio: 1/10.7639
    }
  }
};

var metric$9
  , imperial$7;

metric$9 = {
  mcg: {
    name: {
      singular: 'Microgram'
    , plural: 'Micrograms'
    }
  , to_anchor: 1/1000000
  }
, mg: {
    name: {
      singular: 'Milligram'
    , plural: 'Milligrams'
    }
  , to_anchor: 1/1000
  }
, g: {
    name: {
      singular: 'Gram'
    , plural: 'Grams'
    }
  , to_anchor: 1
  }
, kg: {
    name: {
      singular: 'Kilogram'
    , plural: 'Kilograms'
    }
  , to_anchor: 1000
}
, mt: {
    name: {
      singular: 'Metric Tonne'
    , plural: 'Metric Tonnes'
    }
  , to_anchor: 1000000
  }
};

imperial$7 = {
  oz: {
    name: {
      singular: 'Ounce'
    , plural: 'Ounces'
    }
  , to_anchor: 1/16
  }
, lb: {
    name: {
      singular: 'Pound'
    , plural: 'Pounds'
    }
  , to_anchor: 1
}, t: {
  name: {
    singular: 'Ton',
    plural: 'Tons',
  },
    to_anchor: 2000,
  },
};

var mass = {
  metric: metric$9
, imperial: imperial$7
, _anchors: {
    metric: {
      unit: 'g'
    , ratio: 1/453.592
    }
  , imperial: {
      unit: 'lb'
    , ratio: 453.592
    }
  }
};

var metric$8
  , imperial$6;

metric$8 = {
  mm3: {
      name: {
        singular: 'Cubic Millimeter'
      , plural: 'Cubic Millimeters'
      }
    , to_anchor: 1/1000000
  }
, cm3: {
    name: {
      singular: 'Cubic Centimeter'
    , plural: 'Cubic Centimeters'
    }
  , to_anchor: 1/1000
  }
, ml: {
    name: {
      singular: 'Millilitre'
    , plural: 'Millilitres'
    }
  , to_anchor: 1/1000
  }
, cl: {
    name: {
      singular: 'Centilitre'
    , plural: 'Centilitres'
    }
  , to_anchor: 1/100
  }
, dl: {
    name: {
      singular: 'Decilitre'
    , plural: 'Decilitres'
    }
  , to_anchor: 1/10
  }
, l: {
    name: {
      singular: 'Litre'
    , plural: 'Litres'
    }
  , to_anchor: 1
  }
, kl: {
    name: {
      singular: 'Kilolitre'
    , plural: 'Kilolitres'
    }
  , to_anchor: 1000
  }
, m3: {
    name: {
      singular: 'Cubic meter'
    , plural: 'Cubic meters'
    }
  , to_anchor: 1000
  }
, km3: {
    name: {
      singular: 'Cubic kilometer'
    , plural: 'Cubic kilometers'
    }
  , to_anchor: 1000000000000
  }

// Swedish units
, krm: {
  name: {
    singular: 'Matsked'
    , plural: 'Matskedar'
  }
  , to_anchor: 1/1000
}
, tsk: {
    name: {
      singular: 'Tesked'
    , plural: 'Teskedar'
    }
  , to_anchor: 5/1000
  }
, msk: {
    name: {
      singular: 'Matsked'
      , plural: 'Matskedar'
    }
    , to_anchor: 15/1000
  }
, kkp: {
    name: {
      singular: 'Kaffekopp'
      , plural: 'Kaffekoppar'
    }
    , to_anchor: 150/1000
  }
, glas: {
    name: {
      singular: 'Glas'
      , plural: 'Glas'
    }
    , to_anchor: 200/1000
  }
, kanna: {
    name: {
      singular: 'Kanna'
    , plural: 'Kannor'
    }
  , to_anchor: 2.617
  }
};

imperial$6 = {
  tsp: {
    name: {
      singular: 'Teaspoon'
    , plural: 'Teaspoons'
    }
  , to_anchor: 1/6
  }
, Tbs: {
    name: {
      singular: 'Tablespoon'
    , plural: 'Tablespoons'
    }
  , to_anchor: 1/2
  }
, in3: {
    name: {
      singular: 'Cubic inch'
    , plural: 'Cubic inches'
    }
  , to_anchor: 0.55411
  }
, 'fl-oz': {
    name: {
      singular: 'Fluid Ounce'
    , plural: 'Fluid Ounces'
    }
  , to_anchor: 1
  }
, cup: {
    name: {
      singular: 'Cup'
    , plural: 'Cups'
    }
  , to_anchor: 8
  }
, pnt: {
    name: {
      singular: 'Pint'
    , plural: 'Pints'
    }
  , to_anchor: 16
  }
, qt: {
    name: {
      singular: 'Quart'
    , plural: 'Quarts'
    }
  , to_anchor: 32
  }
, gal: {
    name: {
      singular: 'Gallon'
    , plural: 'Gallons'
    }
  , to_anchor: 128
  }
, ft3: {
    name: {
      singular: 'Cubic foot'
    , plural: 'Cubic feet'
    }
  , to_anchor: 957.506
  }
, yd3: {
    name: {
      singular: 'Cubic yard'
    , plural: 'Cubic yards'
    }
  , to_anchor: 25852.7
  }
};

var volume = {
  metric: metric$8
, imperial: imperial$6
, _anchors: {
    metric: {
      unit: 'l'
    , ratio: 33.8140226
    }
  , imperial: {
      unit: 'fl-oz'
    , ratio: 1/33.8140226
    }
  }
};

var metric$7
  ;

metric$7 = {
  ea: {
    name: {
      singular: 'Each'
    , plural: 'Each'
    }
  , to_anchor: 1
  },
  dz: {
    name: {
      singular: 'Dozen'
    , plural: 'Dozens'
    }
  , to_anchor: 12
  }
};

var each$1 = {
  metric: metric$7
, imperial: {}
, _anchors: {
    metric: {
      unit: 'ea'
    , ratio: 1
    }
  }
};

var metric$6
  , imperial$5;

metric$6 = {
  C: {
    name: {
      singular: 'degree Celsius'
    , plural: 'degrees Celsius'
    }
  , to_anchor: 1
  , anchor_shift: 0
  },
  K: {
    name: {
      singular: 'degree Kelvin'
    , plural: 'degrees Kelvin'
    }
  , to_anchor: 1
  , anchor_shift: 273.15
  }
};

imperial$5 = {
  F: {
    name: {
      singular: 'degree Fahrenheit'
    , plural: 'degrees Fahrenheit'
    }
  , to_anchor: 1
  },
  R: {
    name: {
      singular: 'degree Rankine'
    , plural: 'degrees Rankine'
    }
  , to_anchor: 1
  , anchor_shift: 459.67
  }
};

var temperature = {
  metric: metric$6
, imperial: imperial$5
, _anchors: {
    metric: {
      unit: 'C'
    , transform: function (C) { return C / (5/9) + 32 }
    }
  , imperial: {
      unit: 'F'
    , transform: function (F) { return (F - 32) * (5/9) }
    }
  }
};

var time;
var daysInYear = 365.25;

time = {
  ns: {
    name: {
      singular: 'Nanosecond'
    , plural: 'Nanoseconds'
    }
  , to_anchor: 1/1000000000
  }
, mu: {
    name: {
      singular: 'Microsecond'
    , plural: 'Microseconds'
    }
  , to_anchor: 1/1000000
  }
, ms: {
    name: {
      singular: 'Millisecond'
    , plural: 'Milliseconds'
    }
  , to_anchor: 1/1000
  }
, s: {
    name: {
      singular: 'Second'
    , plural: 'Seconds'
    }
  , to_anchor: 1
  }
, min: {
    name: {
      singular: 'Minute'
    , plural: 'Minutes'
    }
  , to_anchor: 60
  }
, h: {
    name: {
      singular: 'Hour'
    , plural: 'Hours'
    }
  , to_anchor: 60 * 60 
  }
, d: {
    name: {
      singular: 'Day'
    , plural: 'Days'
    }
  , to_anchor: 60 * 60 * 24
  }
, week: {
    name: {
      singular: 'Week'
    , plural: 'Weeks'
    }
  , to_anchor: 60 * 60 * 24 * 7
  }
, month: {
    name: {
      singular: 'Month'
    , plural: 'Months'
    }
  , to_anchor: 60 * 60 * 24 * daysInYear / 12
  }
, year: {
    name: {
      singular: 'Year'
    , plural: 'Years'
    }
  , to_anchor: 60 * 60 * 24 * daysInYear
  }
};


var time_1 = {
  metric: time 
, _anchors: {
    metric: {
      unit: 's'
    , ratio: 1
    }
  }
};

var bits
  , bytes;

bits = {
  b: {
    name: {
      singular: 'Bit'
    , plural: 'Bits'
    }
  , to_anchor: 1
  }
, Kb: {
    name: {
      singular: 'Kilobit'
    , plural: 'Kilobits'
    }
  , to_anchor: 1024
  }
, Mb: {
    name: {
      singular: 'Megabit'
    , plural: 'Megabits'
    }
  , to_anchor: 1048576
  }
, Gb: {
    name: {
      singular: 'Gigabit'
    , plural: 'Gigabits'
    }
  , to_anchor: 1073741824
  }
, Tb: {
    name: {
      singular: 'Terabit'
    , plural: 'Terabits'
    }
  , to_anchor: 1099511627776
  }
};

bytes = {
  B: {
    name: {
      singular: 'Byte'
    , plural: 'Bytes'
    }
  , to_anchor: 1
  }
, KB: {
    name: {
      singular: 'Kilobyte'
    , plural: 'Kilobytes'
    }
  , to_anchor: 1024
  }
, MB: {
    name: {
      singular: 'Megabyte'
    , plural: 'Megabytes'
    }
  , to_anchor: 1048576
  }
, GB: {
    name: {
      singular: 'Gigabyte'
    , plural: 'Gigabytes'
    }
  , to_anchor: 1073741824
  }
, TB: {
    name: {
      singular: 'Terabyte'
    , plural: 'Terabytes'
    }
  , to_anchor: 1099511627776
  }
};

var digital = {
  bits: bits
, bytes: bytes
, _anchors: {
    bits: {
      unit: 'b'
    , ratio: 1/8
    }
  , bytes: {
      unit: 'B'
    , ratio: 8
    }
  }
};

var metric$5
  ;

metric$5 = {
  ppm: {
    name: {
      singular: 'Part-per Million'
      , plural: 'Parts-per Million'
    }
    , to_anchor: 1
  }
  , ppb: {
    name: {
      singular: 'Part-per Billion'
      , plural: 'Parts-per Billion'
    }
    , to_anchor: .001
  }
  , ppt: {
    name: {
      singular: 'Part-per Trillion'
      , plural: 'Parts-per Trillion'
    }
    , to_anchor: .000001
  }
  , ppq: {
    name: {
      singular: 'Part-per Quadrillion'
      , plural: 'Parts-per Quadrillion'
    }
    , to_anchor: .000000001
  }
};

var partsPer = {
  metric: metric$5
  , imperial: {}
  , _anchors: {
    metric: {
      unit: 'ppm'
      , ratio: .000001
    }
  }
};

var metric$4
  , imperial$4;

metric$4 = {
  'm/s': {
    name: {
      singular: 'Metre per second'
    , plural: 'Metres per second'
    }
  , to_anchor: 3.6
  }
, 'km/h': {
    name: {
      singular: 'Kilometre per hour'
    , plural: 'Kilometres per hour'
    }
  , to_anchor: 1
  }
};

  imperial$4 = {
    'm/h': {
      name: {
        singular: 'Mile per hour'
      , plural: 'Miles per hour'
      }
    , to_anchor: 1
    }
  , knot: {
      name: {
        singular: 'Knot'
      , plural: 'Knots'
      }
    , to_anchor: 1.150779
    }
  , 'ft/s': {
      name: {
        singular: 'Foot per second'
      , plural: 'Feet per second'
      }
    , to_anchor: 0.681818
      }
};

var speed = {
  metric: metric$4
, imperial: imperial$4
, _anchors: {
    metric: {
      unit: 'km/h'
    , ratio: 1/1.609344
    }
  , imperial: {
      unit: 'm/h'
    , ratio: 1.609344
    }
  }
};

var metric$3
  , imperial$3;

metric$3 = {
  'min/km': {
    name: {
      singular: 'Minute per kilometre'
    , plural: 'Minutes per kilometre'
    }
  , to_anchor: 0.06
  }
  ,'s/m': {
    name: {
      singular: 'Second per metre'
    , plural: 'Seconds per metre'
    }
  , to_anchor: 1
  }
};

imperial$3 = {
    'min/mi': {
      name: {
        singular: 'Minute per mile'
      , plural: 'Minutes per mile'
      }
    , to_anchor: 0.0113636
   }
   , 's/ft': {
      name: {
        singular: 'Second per foot'
      , plural: 'Seconds per foot'
      }
    , to_anchor: 1
   }
};

var pace = {
  metric: metric$3
, imperial: imperial$3
, _anchors: {
    metric: {
      unit: 's/m'
    , ratio: 0.3048
    }
  , imperial: {
      unit: 's/ft'
    , ratio: 1/0.3048
    }
  }
};

var metric$2
  , imperial$2;

metric$2 = {
  Pa: {
    name: {
      singular: 'pascal'
    , plural: 'pascals'
    }
  , to_anchor: 1/1000
  }
, kPa: {
    name: {
      singular: 'kilopascal'
    , plural: 'kilopascals'
    }
  , to_anchor: 1
  }
, MPa: {
    name: {
      singular: 'megapascal'
    , plural: 'megapascals'
    }
  , to_anchor: 1000
  }
, hPa: {
    name: {
      singular: 'hectopascal'
    , plural: 'hectopascals'
    }
  , to_anchor: 1/10
  }
, bar: {
    name: {
      singular: 'bar'
    , plural: 'bar'
    }
  , to_anchor: 100
  }
, torr: {
    name: {
      singular: 'torr'
    , plural: 'torr'
    }
  , to_anchor: 101325/760000
  }
};

imperial$2 = {
  psi: {
    name: {
      singular: 'pound per square inch'
    , plural: 'pounds per square inch'
    }
  , to_anchor: 1/1000
  }
, ksi: {
    name: {
      singular: 'kilopound per square inch'
    , plural: 'kilopound per square inch'
    }
  , to_anchor: 1
  }
};

var pressure = {
  metric: metric$2
, imperial: imperial$2
, _anchors: {
    metric: {
      unit: 'kPa'
    , ratio: 0.00014503768078
    }
  , imperial: {
      unit: 'psi'
    , ratio: 1/0.00014503768078
    }
  }
};

var current;

current = {
  A: {
    name: {
      singular: 'Ampere'
    , plural: 'Amperes'
    }
  , to_anchor: 1
  }
, mA: {
    name: {
      singular: 'Milliampere'
      , plural: 'Milliamperes'
    }
    , to_anchor: .001
  }
, kA: {
    name: {
      singular: 'Kiloampere'
    , plural: 'Kiloamperes'
    }
  , to_anchor: 1000
  }
};

var current_1 = {
  metric: current
, _anchors: {
    metric: {
      unit: 'A'
    , ratio: 1
    }
  }
};

var voltage;

voltage = {
  V: {
    name: {
      singular: 'Volt'
    , plural: 'Volts'
    }
  , to_anchor: 1
  }
, mV: {
    name: {
      singular: 'Millivolt'
      , plural: 'Millivolts'
    }
    , to_anchor: .001
  }
, kV: {
    name: {
      singular: 'Kilovolt'
    , plural: 'Kilovolts'
    }
  , to_anchor: 1000
  }
};

var voltage_1 = {
  metric: voltage
, _anchors: {
    metric: {
      unit: 'V'
    , ratio: 1
    }
  }
};

var power;

power = {
  W: {
    name: {
      singular: 'Watt'
    , plural: 'Watts'
    }
  , to_anchor: 1
  }
, mW: {
    name: {
      singular: 'Milliwatt'
      , plural: 'Milliwatts'
    }
    , to_anchor: .001
  }
, kW: {
    name: {
      singular: 'Kilowatt'
    , plural: 'Kilowatts'
    }
  , to_anchor: 1000
  }
, MW: {
    name: {
      singular: 'Megawatt'
    , plural: 'Megawatts'
    }
  , to_anchor: 1000000
  }
, GW: {
    name: {
      singular: 'Gigawatt'
    , plural: 'Gigawatts'
    }
  , to_anchor: 1000000000
  }
};

var power_1 = {
  metric: power
, _anchors: {
    metric: {
      unit: 'W'
    , ratio: 1
    }
  }
};

var reactivePower;

reactivePower = {
  VAR: {
    name: {
      singular: 'Volt-Ampere Reactive'
    , plural: 'Volt-Amperes Reactive'
    }
  , to_anchor: 1
  }
, mVAR: {
    name: {
      singular: 'Millivolt-Ampere Reactive'
      , plural: 'Millivolt-Amperes Reactive'
    }
    , to_anchor: .001
  }
, kVAR: {
    name: {
      singular: 'Kilovolt-Ampere Reactive'
    , plural: 'Kilovolt-Amperes Reactive'
    }
  , to_anchor: 1000
  }
, MVAR: {
    name: {
      singular: 'Megavolt-Ampere Reactive'
    , plural: 'Megavolt-Amperes Reactive'
    }
  , to_anchor: 1000000
  }
, GVAR: {
    name: {
      singular: 'Gigavolt-Ampere Reactive'
    , plural: 'Gigavolt-Amperes Reactive'
    }
  , to_anchor: 1000000000
  }
};

var reactivePower_1 = {
  metric: reactivePower
, _anchors: {
    metric: {
      unit: 'VAR'
    , ratio: 1
    }
  }
};

var apparentPower;

apparentPower = {
  VA: {
    name: {
      singular: 'Volt-Ampere'
    , plural: 'Volt-Amperes'
    }
  , to_anchor: 1
  }
, mVA: {
    name: {
      singular: 'Millivolt-Ampere'
      , plural: 'Millivolt-Amperes'
    }
    , to_anchor: .001
  }
, kVA: {
    name: {
      singular: 'Kilovolt-Ampere'
    , plural: 'Kilovolt-Amperes'
    }
  , to_anchor: 1000
  }
, MVA: {
    name: {
      singular: 'Megavolt-Ampere'
    , plural: 'Megavolt-Amperes'
    }
  , to_anchor: 1000000
  }
, GVA: {
    name: {
      singular: 'Gigavolt-Ampere'
    , plural: 'Gigavolt-Amperes'
    }
  , to_anchor: 1000000000
  }
};

var apparentPower_1 = {
  metric: apparentPower
, _anchors: {
    metric: {
      unit: 'VA'
    , ratio: 1
    }
  }
};

var energy;

energy = {
  Wh: {
    name: {
      singular: 'Watt-hour'
    , plural: 'Watt-hours'
    }
  , to_anchor: 3600
  }
, mWh: {
    name: {
      singular: 'Milliwatt-hour'
      , plural: 'Milliwatt-hours'
    }
    , to_anchor: 3.6
  }
, kWh: {
    name: {
      singular: 'Kilowatt-hour'
    , plural: 'Kilowatt-hours'
    }
  , to_anchor: 3600000
  }
, MWh: {
    name: {
      singular: 'Megawatt-hour'
    , plural: 'Megawatt-hours'
    }
  , to_anchor: 3600000000
  }
, GWh: {
    name: {
      singular: 'Gigawatt-hour'
    , plural: 'Gigawatt-hours'
    }
  , to_anchor: 3600000000000
  }
, J: {
    name: {
      singular: 'Joule'
    , plural: 'Joules'
    }
  , to_anchor: 1
  }
, kJ: {
    name: {
      singular: 'Kilojoule'
    , plural: 'Kilojoules'
    }
  , to_anchor: 1000
  }
};

var energy_1 = {
  metric: energy
, _anchors: {
    metric: {
      unit: 'J'
    , ratio: 1
    }
  }
};

var reactiveEnergy;

reactiveEnergy = {
  VARh: {
    name: {
      singular: 'Volt-Ampere Reactive Hour'
    , plural: 'Volt-Amperes Reactive Hour'
    }
  , to_anchor: 1
  }
, mVARh: {
    name: {
      singular: 'Millivolt-Ampere Reactive Hour'
      , plural: 'Millivolt-Amperes Reactive Hour'
    }
    , to_anchor: .001
  }
, kVARh: {
    name: {
      singular: 'Kilovolt-Ampere Reactive Hour'
    , plural: 'Kilovolt-Amperes Reactive Hour'
    }
  , to_anchor: 1000
  }
, MVARh: {
    name: {
      singular: 'Megavolt-Ampere Reactive Hour'
    , plural: 'Megavolt-Amperes Reactive Hour'
    }
  , to_anchor: 1000000
  }
, GVARh: {
    name: {
      singular: 'Gigavolt-Ampere Reactive Hour'
    , plural: 'Gigavolt-Amperes Reactive Hour'
    }
  , to_anchor: 1000000000
  }
};

var reactiveEnergy_1 = {
  metric: reactiveEnergy
, _anchors: {
    metric: {
      unit: 'VARh'
    , ratio: 1
    }
  }
};

var metric$1
  , imperial$1;

metric$1 = {
  'mm3/s': {
      name: {
        singular: 'Cubic Millimeter per second'
      , plural: 'Cubic Millimeters per second'
      }
    , to_anchor: 1/1000000
  }
, 'cm3/s': {
    name: {
      singular: 'Cubic Centimeter per second'
    , plural: 'Cubic Centimeters per second'
    }
  , to_anchor: 1/1000
  }
, 'ml/s': {
    name: {
      singular: 'Millilitre per second'
    , plural: 'Millilitres per second'
    }
  , to_anchor: 1/1000
  }
, 'cl/s': {
    name: {
      singular: 'Centilitre per second'
    , plural: 'Centilitres per second'
    }
  , to_anchor: 1/100
  }
, 'dl/s': {
    name: {
      singular: 'Decilitre per second'
    , plural: 'Decilitres per second'
    }
  , to_anchor: 1/10
  }
, 'l/s': {
    name: {
      singular: 'Litre per second'
    , plural: 'Litres per second'
    }
  , to_anchor: 1
  }
, 'l/min': {
    name: {
      singular: 'Litre per minute'
    , plural: 'Litres per minute'
    }
  , to_anchor: 1/60
  }
, 'l/h': {
    name: {
      singular: 'Litre per hour'
    , plural: 'Litres per hour'
    }
  , to_anchor: 1/3600
  }
, 'kl/s': {
    name: {
      singular: 'Kilolitre per second'
    , plural: 'Kilolitres per second'
    }
  , to_anchor: 1000
  }
, 'kl/min': {
    name: {
      singular: 'Kilolitre per minute'
    , plural: 'Kilolitres per minute'
    }
  , to_anchor: 50/3
  }
, 'kl/h': {
    name: {
      singular: 'Kilolitre per hour'
    , plural: 'Kilolitres per hour'
    }
  , to_anchor: 5/18
  }
, 'm3/s': {
    name: {
      singular: 'Cubic meter per second'
    , plural: 'Cubic meters per second'
    }
  , to_anchor: 1000
  }
, 'm3/min': {
    name: {
      singular: 'Cubic meter per minute'
    , plural: 'Cubic meters per minute'
    }
  , to_anchor: 50/3
  }
, 'm3/h': {
    name: {
      singular: 'Cubic meter per hour'
    , plural: 'Cubic meters per hour'
    }
  , to_anchor: 5/18
  }
, 'km3/s': {
    name: {
      singular: 'Cubic kilometer per second'
    , plural: 'Cubic kilometers per second'
    }
  , to_anchor: 1000000000000
  }
};

imperial$1 = {
  'tsp/s': {
    name: {
      singular: 'Teaspoon per second'
    , plural: 'Teaspoons per second'
    }
  , to_anchor: 1/6
  }
, 'Tbs/s': {
    name: {
      singular: 'Tablespoon per second'
    , plural: 'Tablespoons per second'
    }
  , to_anchor: 1/2
  }
, 'in3/s': {
    name: {
      singular: 'Cubic inch per second'
    , plural: 'Cubic inches per second'
    }
  , to_anchor: 0.55411
  }
, 'in3/min': {
    name: {
      singular: 'Cubic inch per minute'
    , plural: 'Cubic inches per minute'
    }
  , to_anchor: 0.55411/60
  }
, 'in3/h': {
    name: {
      singular: 'Cubic inch per hour'
    , plural: 'Cubic inches per hour'
    }
  , to_anchor: 0.55411/3600
  }
, 'fl-oz/s': {
    name: {
      singular: 'Fluid Ounce per second'
    , plural: 'Fluid Ounces per second'
    }
  , to_anchor: 1
  }
, 'fl-oz/min': {
    name: {
      singular: 'Fluid Ounce per minute'
    , plural: 'Fluid Ounces per minute'
    }
  , to_anchor: 1/60
  }
, 'fl-oz/h': {
    name: {
      singular: 'Fluid Ounce per hour'
    , plural: 'Fluid Ounces per hour'
    }
  , to_anchor: 1/3600
  }
, 'cup/s': {
    name: {
      singular: 'Cup per second'
    , plural: 'Cups per second'
    }
  , to_anchor: 8
  }
, 'pnt/s': {
    name: {
      singular: 'Pint per second'
    , plural: 'Pints per second'
    }
  , to_anchor: 16
  }
, 'pnt/min': {
    name: {
      singular: 'Pint per minute'
    , plural: 'Pints per minute'
    }
  , to_anchor: 4/15
  }
, 'pnt/h': {
    name: {
      singular: 'Pint per hour'
    , plural: 'Pints per hour'
    }
  , to_anchor: 1/225
  }
, 'qt/s': {
    name: {
      singular: 'Quart per second'
    , plural: 'Quarts per second'
    }
  , to_anchor: 32
  }
, 'gal/s': {
    name: {
      singular: 'Gallon per second'
    , plural: 'Gallons per second'
    }
  , to_anchor: 128
  }
, 'gal/min': {
    name: {
      singular: 'Gallon per minute'
    , plural: 'Gallons per minute'
    }
  , to_anchor: 32/15
  }
, 'gal/h': {
    name: {
      singular: 'Gallon per hour'
    , plural: 'Gallons per hour'
    }
  , to_anchor: 8/225
  }
, 'ft3/s': {
    name: {
      singular: 'Cubic foot per second'
    , plural: 'Cubic feet per second'
    }
  , to_anchor: 957.506
  }
, 'ft3/min': {
    name: {
      singular: 'Cubic foot per minute'
    , plural: 'Cubic feet per minute'
    }
  , to_anchor: 957.506/60
  }
, 'ft3/h': {
    name: {
      singular: 'Cubic foot per hour'
    , plural: 'Cubic feet per hour'
    }
  , to_anchor: 957.506/3600
  }
, 'yd3/s': {
    name: {
      singular: 'Cubic yard per second'
    , plural: 'Cubic yards per second'
    }
  , to_anchor: 25852.7
  }
, 'yd3/min': {
    name: {
      singular: 'Cubic yard per minute'
    , plural: 'Cubic yards per minute'
    }
  , to_anchor: 25852.7/60
  }
, 'yd3/h': {
    name: {
      singular: 'Cubic yard per hour'
    , plural: 'Cubic yards per hour'
    }
  , to_anchor: 25852.7/3600
  }
};

var volumeFlowRate = {
  metric: metric$1
, imperial: imperial$1
, _anchors: {
    metric: {
      unit: 'l/s'
    , ratio: 33.8140227
    }
  , imperial: {
      unit: 'fl-oz/s'
    , ratio: 1/33.8140227
    }
  }
};

var metric,
imperial;

metric = {
  'lx': {
    name: {
      singular: 'Lux',
      plural: 'Lux'
    },
    to_anchor: 1
  }
};

imperial = {
  'ft-cd': {
    name: {
      singular: 'Foot-candle',
      plural: 'Foot-candles'
    },
    to_anchor: 1
  }
};

var illuminance = {
  metric: metric,
  imperial: imperial,
  _anchors: {
    metric: {
      unit: 'lx',
      ratio: 1/10.76391
    },
    imperial: {
      unit: 'ft-cd',      
	  ratio: 10.76391
    }
  }
};

var frequency;

frequency = {
  mHz: {
    name: {
      singular: 'millihertz'
    , plural: 'millihertz'
    }
  , to_anchor: 1/1000
  }
, Hz: {
    name: {
      singular: 'hertz'
    , plural: 'hertz'
    }
  , to_anchor: 1
  }
, kHz: {
    name: {
      singular: 'kilohertz'
    , plural: 'kilohertz'
    }
  , to_anchor: 1000
  }
, MHz: {
    name: {
      singular: 'megahertz'
    , plural: 'megahertz'
    }
  , to_anchor: 1000 * 1000
  }
, GHz: {
    name: {
      singular: 'gigahertz'
    , plural: 'gigahertz'
    }
  , to_anchor: 1000 * 1000 * 1000
  }
, THz: {
    name: {
      singular: 'terahertz'
    , plural: 'terahertz'
    }
  , to_anchor: 1000 * 1000 * 1000 * 1000
  }
, rpm: {
    name: {
      singular: 'rotation per minute'
    , plural: 'rotations per minute'
    }
  , to_anchor: 1/60
  }
, "deg/s": {
    name: {
      singular: 'degree per second'
    , plural: 'degrees per second'
    }
  , to_anchor: 1/360
  }
, "rad/s": {
    name: {
      singular: 'radian per second'
    , plural: 'radians per second'
    }
  , to_anchor: 1/(Math.PI * 2)
  }
};


var frequency_1 = {
  metric: frequency
, _anchors: {
    frequency: {
      unit: 'hz'
    , ratio: 1
    }
  }
};

var angle;

angle = {
  rad: {
    name: {
      singular: 'radian'
    , plural: 'radians'
    }
  , to_anchor: 180/Math.PI
  }
, deg: {
    name: {
      singular: 'degree'
    , plural: 'degrees'
    }
  , to_anchor: 1
  }
, grad: {
    name: {
      singular: 'gradian'
    , plural: 'gradians'
    }
  , to_anchor: 9/10
  }
, arcmin: {
    name: {
      singular: 'arcminute'
    , plural: 'arcminutes'
    }
  , to_anchor: 1/60
  }
, arcsec: {
    name: {
      singular: 'arcsecond'
    , plural: 'arcseconds'
    }
  , to_anchor: 1/3600
  }
};

var angle_1 = {
  metric: angle
, _anchors: {
    metric: {
      unit: 'deg'
    , ratio: 1
    }
  }
};

var convert
  , keys = lodash_keys
  , each = lodash_foreach
  , measures = {
      length: length
    , area: area
    , mass: mass
    , volume: volume
    , each: each$1
    , temperature: temperature
    , time: time_1
    , digital: digital
    , partsPer: partsPer
    , speed: speed
    , pace: pace
    , pressure: pressure
    , current: current_1
    , voltage: voltage_1
    , power: power_1
    , reactivePower: reactivePower_1
    , apparentPower: apparentPower_1
    , energy: energy_1
    , reactiveEnergy: reactiveEnergy_1
    , volumeFlowRate: volumeFlowRate
    , illuminance: illuminance
    , frequency: frequency_1
    , angle : angle_1
    }
  , Converter;

Converter = function (numerator, denominator) {
  if(denominator)
    this.val = numerator / denominator;
  else
    this.val = numerator;
};

/**
* Lets the converter know the source unit abbreviation
*/
Converter.prototype.from = function (from) {
  if(this.destination)
    throw new Error('.from must be called before .to');

  this.origin = this.getUnit(from);

  if(!this.origin) {
    this.throwUnsupportedUnitError(from);
  }

  return this;
};

/**
* Converts the unit and returns the value
*/
Converter.prototype.to = function (to) {
  if(!this.origin)
    throw new Error('.to must be called after .from');

  this.destination = this.getUnit(to);

  var result
    , transform;

  if(!this.destination) {
    this.throwUnsupportedUnitError(to);
  }

  // Don't change the value if origin and destination are the same
  if (this.origin.abbr === this.destination.abbr) {
    return this.val;
  }

  // You can't go from liquid to mass, for example
  if(this.destination.measure != this.origin.measure) {
    throw new Error('Cannot convert incompatible measures of '
      + this.destination.measure + ' and ' + this.origin.measure);
  }

  /**
  * Convert from the source value to its anchor inside the system
  */
  result = this.val * this.origin.unit.to_anchor;

  /**
  * For some changes it's a simple shift (C to K)
  * So we'll add it when convering into the unit (later)
  * and subtract it when converting from the unit
  */
  if (this.origin.unit.anchor_shift) {
    result -= this.origin.unit.anchor_shift;
  }

  /**
  * Convert from one system to another through the anchor ratio. Some conversions
  * aren't ratio based or require more than a simple shift. We can provide a custom
  * transform here to provide the direct result
  */
  if(this.origin.system != this.destination.system) {
    transform = measures[this.origin.measure]._anchors[this.origin.system].transform;
    if (typeof transform === 'function') {
      result = transform(result);
    }
    else {
      result *= measures[this.origin.measure]._anchors[this.origin.system].ratio;
    }
  }

  /**
  * This shift has to be done after the system conversion business
  */
  if (this.destination.unit.anchor_shift) {
    result += this.destination.unit.anchor_shift;
  }

  /**
  * Convert to another unit inside the destination system
  */
  return result / this.destination.unit.to_anchor;
};

/**
* Converts the unit to the best available unit.
*/
Converter.prototype.toBest = function(options) {
  if(!this.origin)
    throw new Error('.toBest must be called after .from');

  var options = Object.assign({
    exclude: [],
    cutOffNumber: 1,
  }, options);

  var best;
  /**
    Looks through every possibility for the 'best' available unit.
    i.e. Where the value has the fewest numbers before the decimal point,
    but is still higher than 1.
  */
  each(this.possibilities(), function(possibility) {
    var unit = this.describe(possibility);
    var isIncluded = options.exclude.indexOf(possibility) === -1;

    if (isIncluded && unit.system === this.origin.system) {
      var result = this.to(possibility);
      if (!best || (result >= options.cutOffNumber && result < best.val)) {
        best = {
          val: result,
          unit: possibility,
          singular: unit.singular,
          plural: unit.plural
        };
      }
    }
  }.bind(this));

  return best;
};

/**
* Finds the unit
*/
Converter.prototype.getUnit = function (abbr) {
  var found;

  each(measures, function (systems, measure) {
    each(systems, function (units, system) {
      if(system == '_anchors')
        return false;

      each(units, function (unit, testAbbr) {
        if(testAbbr == abbr) {
          found = {
            abbr: abbr
          , measure: measure
          , system: system
          , unit: unit
          };
          return false;
        }
      });

      if(found)
        return false;
    });

    if(found)
      return false;
  });

  return found;
};

var describe = function(resp) {
  return {
    abbr: resp.abbr
  , measure: resp.measure
  , system: resp.system
  , singular: resp.unit.name.singular
  , plural: resp.unit.name.plural
  };
};

/**
* An alias for getUnit
*/
Converter.prototype.describe = function (abbr) {
  var resp = Converter.prototype.getUnit(abbr);
  var desc = null;

  try {
    desc = describe(resp);
  } catch(err) {
    this.throwUnsupportedUnitError(abbr);
  }

  return desc;
};

/**
* Detailed list of all supported units
*/
Converter.prototype.list = function (measure) {
  var list = [];

  each(measures, function (systems, testMeasure) {
    if(measure && measure !== testMeasure)
      return;

    each(systems, function (units, system) {
      if(system == '_anchors')
        return false;

      each(units, function (unit, abbr) {
        list = list.concat(describe({
          abbr: abbr,
          measure: testMeasure
        , system: system
        , unit: unit
        }));
      });
    });
  });

  return list;
};

Converter.prototype.throwUnsupportedUnitError = function (what) {
  var validUnits = [];

  each(measures, function (systems, measure) {
    each(systems, function (units, system) {
      if(system == '_anchors')
        return false;

      validUnits = validUnits.concat(keys(units));
    });
  });

  throw new Error('Unsupported unit ' + what + ', use one of: ' + validUnits.join(', '));
};

/**
* Returns the abbreviated measures that the value can be
* converted to.
*/
Converter.prototype.possibilities = function (measure) {
  var possibilities = [];
  if(!this.origin && !measure) {
	  each(keys(measures), function (measure){
		  each(measures[measure], function (units, system) {
		    if(system == '_anchors')
		      return false;

		    possibilities = possibilities.concat(keys(units));
		  });
	  });
  } else {
	  measure = measure || this.origin.measure;
	  each(measures[measure], function (units, system) {
	    if(system == '_anchors')
	      return false;

	    possibilities = possibilities.concat(keys(units));
	  });
  }

  return possibilities;
};

/**
* Returns the abbreviated measures that the value can be
* converted to.
*/
Converter.prototype.measures = function () {
  return keys(measures);
};

convert = function (value) {
  return new Converter(value);
};

var lib = convert;

const getUnit = (unit, aliases) => { var _a; return ((_a = aliases.find((el) => el.aliases.includes(unit))) === null || _a === void 0 ? void 0 : _a.unit) || unit; };
const formatUnit = (value, unit, t, digits = 2) => `${+(value === null || value === void 0 ? void 0 : value.toFixed(digits))} ${t(unit)}`;
const convertUnit = (value, originalUnit, displayUnit, aliases, t, digits) => {
    if (!displayUnit)
        return formatUnit(value, originalUnit, t, digits);
    if (aliases === null || aliases === void 0 ? void 0 : aliases.length) {
        originalUnit = getUnit(originalUnit, aliases);
        displayUnit = getUnit(displayUnit, aliases);
    }
    try {
        let convertedValue;
        if (displayUnit === 'bestFit') {
            const bestFit = lib(value).from(originalUnit).toBest();
            displayUnit = bestFit.unit;
            convertedValue = bestFit.val;
        }
        else {
            convertedValue = lib(value).from(originalUnit).to(displayUnit);
        }
        return formatUnit(convertedValue, displayUnit, t);
    }
    catch (error) {
        return formatUnit(value, originalUnit, t);
    }
};
// 'ns'| 'mu' | 'ms' | 's' | 'min' | 'h' | 'd' | 'week' | 'month' | 'year';
// 'B' | 'KB' | 'MB' | 'GB' | 'TB';
// bestFit => (the smallest unit with a value above 1)

const formatDate = (date, outputDateFormat) => dayjs(date).format(outputDateFormat);

/**
 * The function converts an amount from one currency unit to another based on predefined conversion
 * rates.
 * @param {number} amount - a number representing the amount of currency to be converted
 * @param {CurrencyUnit} currencyUnit - The currency unit is a string literal type that can only take
 * one of the four values: 'CENT', 'PENNY', 'EUR', or 'USD'. It specifies the unit of currency that the
 * amount parameter is in.
 * @returns a string, which is the converted amount based on the input amount and currency unit.
 */
function convertCurrencyUnits(amount, currencyUnit) {
    // Conversion rates
    const conversionRates = {
        CENT: 0.01,
        PENNY: 0.01,
        EUR: 1,
        USD: 1,
    };
    // Validate units
    if (!(currencyUnit.toUpperCase() in conversionRates)) {
        return 'N/A';
    }
    // Perform conversion
    const convertedAmount = amount * conversionRates[currencyUnit];
    return convertedAmount.toString();
}

var index = {
    formatMoney,
    getValueFromJson,
    formatMB,
    mapProductTMF,
    setInsuranceType,
    convertUnit,
    formatDate,
    convertCurrencyUnits,
};

export { AccessoryCard, AddonCard$1 as AddonCard, AddonDate, AddonDetails, AddonCard as AddonsCard, AddonsListing, AddressTray, TrayContent as AddressTrayContent, TrayHeader as AddressTrayHeader, Card, CardBody, CardHeader$1 as CardHeader, Compare, Consumption, ErrorContent, ErrorModal, Filter, GalleryWithPreview, GapContainer, GenericUpSellingCard, Gift, ImagePickerItem, ImagePlanCard, ImagePlanCardListing, ModalContent, OrderAndValidationModal, PlanCard, PlanListing, PriceOffering, ProductCard, ProductSIMCard, QuickFilter, RedirectionPage, RenewAndValidity, ServicesIncluded, StickyWrapper, TangibleProductCard, TangibleProductListing, TileButton, TopBar, TopUpAmount, UpSellingCard, index as utils };
//# sourceMappingURL=index.js.map
